<template>
  <el-container class="layout" :class="{ 'layout-screen': isScreen }">
    <el-container class="main">
      <el-main class="body row" :class="{ 'body-screen': isScreen }" style="overflow: hidden;">
        <!-- 视频播放器 -->
        <div ref="videoWrapper" class="body-container" style="position: relative;overflow: hidden;">
          <div
            v-show="isLoadVideo"
            ref="video"
            v-tap="(e)=>onTouchPay(e)"
            class="index"
            @click.left="onClickLeft"
          >
            <div v-if="errorMsg" class="modal-wrapper">
              <div class="modal">
                <el-result icon="error" title="错误提示" :sub-title="errorMsg">
                  <template slot="extra">
                    <el-button
                      type="primary"
                      icon="el-icon-refresh"
                      size="large"
                      @click="onReload"
                    >重试</el-button>
                  </template>
                </el-result>
              </div>
            </div>
            <video
              ref="videoPlayer"
              class="video-js"
              style="outline: none;"
              oncontextmenu="return false;"
              :class="{ blur: isBlur , 'video-radius':!isScreen && !isOpenHollow,'video-radius-angle':!isScreen && isOpenHollow}"
              @click.left="onClickLeft"
              @click.middle="onClickMiddle"
              @contextmenu.prevent="onClickRight"
            >
              <p class="vjs-no-js">若要查看此视频，请启用JavaScript，并考虑升级到Web浏览器</p>
            </video>
            <div
              v-if="videoPath.includes('mp3')"
              style="position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;color: red;display: flex;justify-content: center;align-items: center;"
            >
              <el-image
                style="width: 200px;height: 200px;"
                :src="require('@/assets/record.webp')"
                fit="fit"
                lazy
              />
            </div>
          </div>
          <el-empty v-if="!isLoadVideo" class="empty" description="视频播放空空如也~" />
          <!-- 返回主页 -->
          <div
            :style="{opacity: isFileName?'1':'0'}"
            style="position: absolute;
            top: 0px;
            height: 50px;
            left: 10px;
            right: 10px;
            background: linear-gradient(rgb(4, 4, 4), rgba(4, 4, 4, 0.5),rgba(0, 0, 0, 0.01) );
            color: white;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            border-radius: 10px;"
            @mouseover="isFileName=true;"
            @mouseleave="isFileName=false;"
          >
            <i
              class="el-icon-back"
              style="font-size: 20px;font-weight: bold;margin-left: 10px;cursor:pointer;"
              @click="onBack()"
            ></i>
            <span style="margin-left:10px;cursor:pointer;" @click="onBack()">{{ isNameHollow.name }}</span>
          </div>
          <!-- 底部控制区 -->
          <div
            style="position: absolute;bottom: 0px;"
            class="layout-contoller"
            :class="{ 'layout-contoller-Screen': isScreen }"
          >
            <!--字幕部分-->
            <div class="subtitle-div">
              <div
                v-if="isStartPlay"
                v-tap="(e)=>onTouch('点击',e)"
                v-longtap="(e)=>onTouch('长按',e)"
                v-swiperight="(e)=>onTouch('右滑',e)"
                class="body-subtitle"
                :class="{ blur: isBlur && !dialogDictionaryVisible && hideSubtitle, hide: hideSubtitle && !dialogDictionaryVisible }"
                @mouseup="handleMouseUp();"
              >
                <template v-if="isShowSubtitle">
                  <!-- 中文 -->
                  <div
                    v-if="currentSubtitleZh!=null &&currentSubtitleZh.length>0 "
                    id="zh"
                    class="zh"
                    :class="[isShowChinessSubtitle?'show':'hide']"
                    :style="{fontSize: zhFontSize + 'px'}"
                  >
                    <span>{{ currentSubtitleZh }}</span>
                  </div>
                  <!-- 英文 -->
                  <div
                    v-if="currentSubtitle !==null && currentSubtitle.length>0"
                    id="en"
                    v-popover:popover
                    class="en column"
                    :style="{fontSize: enFontSize + 'px'}"
                    style="z-index: 0;"
                    @mouseover="onMouseoverSubtitle()"
                    @mouseleave="onMouseleaveSubtitle();"
                  >
                    <!-- 英文字情景视频样式 -->
                    <span
                      ref="enSceneSubtitle"
                      style="color: transparent;"
                      v-html="currentSubtitle"
                    ></span>
                    <!-- 英文字挖空样式 -->
                    <span
                      style="z-index: 0;"
                      :style="{marginTop: hollowMarginTop + 'px',color:!isEnglishText? 'white':'transparent'}"
                      v-html="currentSubtitleHollow"
                    ></span>
                    <!-- 英文字幕不带样式 分割 选词 -->
                    <span
                      v-if="isEnglishText || dialogDictionaryVisible"
                      ref="englishTextEl"
                      style="z-index: 1;"
                      :style="{marginTop: hollowMarginTop + 'px'}"
                    >
                      <span
                        v-for="(item, index) in englishText"
                        :id="'en'+index"
                        :key="index"
                        class="btn"
                        data-clipboard-action="cut"
                        :class="{ 'take-background':item.isSelected }"
                        @mouseover="onMouseoverTake(index,item)"
                        @mousedown="onMousedownTake(index,item)"
                        @mouseup="onMouseupTake"
                      >{{ item.content }}</span>
                    </span>
                    <!-- 字幕联想视频 -->
                    <div
                      v-if=" (isShowAssociation || isShowNote)"
                      title="字幕联想视频"
                      class="association"
                      @click="handleShowAssociationDialog"
                    >
                      <div class="contanier">
                        <div class="dot"></div>
                        <div class="pulse"></div>
                        <div class="pulse1"></div>
                      </div>
                    </div>
                    <!-- 笔记 -->
                    <div
                      v-if="jurisdiction.functions['an'] && !(addNoteHtmlIng || !isShowSubtitle)"
                      class="association notes-news"
                      @click="handleShowAddNoteDialog"
                    >
                      <img src="../assets/images/player/笔记.png" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- 控制栏 -->
            <div
              style="background: linear-gradient(rgb(0 0 0 / 1%), rgb(4 4 4 / 70%), rgb(4, 4, 4));"
              :style="{borderRadius:isScreen===true?'0px': isOpenHollow?'0px 0px 0px 10px': '0px 0px 10px 10px'}"
            >
              <div
                v-if="isControl"
                class="control"
                style="margin: 0px 0px 10px 0px;margin-bottom: -8px;"
              >
                <!--播放区-->
                <div class="paly">
                  <div class="play-pause" :title="playOrPauseTitle" @click="onTogglePlay">
                    <svg
                      v-if="!isPlay"
                      class="play-icon"
                      t="1632038826276"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="730"
                    >
                      <path
                        d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                        p-id="731"
                        :fill="primaryColor"
                      />
                    </svg>
                    <svg
                      v-else
                      t="1632066311123"
                      class="pause-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2390"
                    >
                      <path
                        :style="{ fill: isScreenFill }"
                        d="M142.222222 0m99.555556 0l0 0q99.555556 0 99.555555 99.555556l0 824.888888q0 99.555556-99.555555 99.555556l0 0q-99.555556 0-99.555556-99.555556l0-824.888888q0-99.555556 99.555556-99.555556Z"
                        p-id="2391"
                      />
                      <path
                        d="M682.666667 0m99.555555 0l0 0q99.555556 0 99.555556 99.555556l0 824.888888q0 99.555556-99.555556 99.555556l0 0q-99.555556 0-99.555555-99.555556l0-824.888888q0-99.555556 99.555555-99.555556Z"
                        :style="{ fill: isScreenFill }"
                        p-id="2392"
                      />
                    </svg>
                  </div>
                  <!--上下句-->
                  <div class="voice">
                    <span v-if="jurisdiction.functions['jfns']" title="上一句" @click="onLastSentence">
                      <svg
                        t="1632040304257"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="753"
                        width="14"
                        height="14"
                      >
                        <path
                          d="M57.727096 4.248201c11.271894 0 22.090646 3.823381 30.020621 10.648824a33.985609 33.985609 0 0 1 12.46139 25.772421v946.725787c0 20.108152-19.031941 36.421245-42.482011 36.421245S15.245084 1007.503385 15.245084 987.395233V40.641124C15.245084 20.532972 34.277026 4.248201 57.727096 4.248201z m910.87097 9.431007a73.097381 73.097381 0 0 1 35.854817 63.383161v873.883298a73.097381 73.097381 0 0 1-35.854817 63.383161 68.990787 68.990787 0 0 1-71.284816-0.934604L189.194761 576.452575v0.028321a73.267309 73.267309 0 0 1-34.382108-62.448557c0-25.602492 13.027817-49.307455 34.382108-62.476878L897.31325 14.613812a68.990787 68.990787 0 0 1 71.284816-0.934604z"
                          :style="{ fill: isScreenFill }"
                          p-id="754"
                        />
                      </svg>
                    </span>
                    <span v-if="jurisdiction.functions['jfns']" title="下一句" @click="onNextSentence">
                      <svg
                        t="1632040345330"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="996"
                        width="14"
                        height="14"
                        style="margin-left:20px;"
                      >
                        <path
                          d="M967.11117 0.000284c-11.320879 0-22.186648 3.839997-30.151086 10.723547a34.133305 34.133305 0 0 0-12.515545 25.855979v950.840096c0 20.195539 19.114651 36.579525 42.666631 36.579525s42.666631-16.383986 42.666631-36.579525V36.57981C1009.777801 16.384271 990.663151 0.000284 967.11117 0.000284zM50.205268 9.500721A73.41505 73.41505 0 0 0 14.223076 73.159335v877.681046a73.41505 73.41505 0 0 0 35.982192 63.658614 69.290609 69.290609 0 0 0 71.594607-0.938666l711.195852-438.840523v0.028444A73.585716 73.585716 0 0 0 867.555698 512.028302c0-25.713756-13.112878-49.521737-34.559971-62.748392L121.799875 10.439387A69.290609 69.290609 0 0 0 50.205268 9.500721z"
                          p-id="997"
                          :style="{ fill: isScreenFill }"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <!--功能-->
                <div class="function">
                  <span v-if="jurisdiction.functions['avc'] && !locality" title="收藏" @click="onAvCollect">
                    <img
                      v-if="!isAvCollect"
                      src="../assets/images/player/未收藏.png"
                      style="width: 16px;margin-top: 3px;"
                    />
                    <img
                      v-else
                      src="../assets/images/player/已收藏.png"
                      style="width: 16px;margin-top: 3px;"
                    />
                  </span>
                  <span title="单句播放暂停" @click="onSimplePause">
                    <svg t="1720788010573" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4249" width="64" height="64"><path
                      d="M968.704 379.712l-30.72 92.48-21.376 64.704a4.032 4.032 0 0 1-6.784 1.408l-32.192-36.096-77.952-87.616a4.032 4.032 0 0 1 2.24-6.592l28.16-5.76a16 16 0 0 0 11.008-22.912 367.552 367.552 0 0 0-68.992-95.552 366.912 366.912 0 0 0-100.224-71.296 269.312 269.312 0 0 0-13.44-5.952 16 16 0 0 0-20.48 6.976 144 144 0 1 1 17.024-86.528 16 16 0 0 0 10.304 13.056A433.152 433.152 0 0 1 908.8 372.864c3.008 6.976 10.496 10.88 17.92 9.28l37.376-7.68a3.968 3.968 0 0 1 4.608 5.12z m39.296 357.696a144.448 144.448 0 0 1-148.8 142.464 144.192 144.192 0 0 1-49.728-10.56 16 16 0 0 0-16.448 2.688A429.568 429.568 0 0 1 512 976c-19.84 0-39.232-1.28-58.368-3.84a16 16 0 0 0-17.088 10.048l-12.992 33.664a3.968 3.968 0 0 1-6.784 1.152l-54.72-67.712-49.408-61.12a4.032 4.032 0 0 1 2.56-6.464l37.312-5.952 126.208-19.84a4.032 4.032 0 0 1 4.48 5.376l-10.88 28.096a16 16 0 0 0 13.952 21.696 364.992 364.992 0 0 0 168.96-28.032 366.144 366.144 0 0 0 83.2-48.96 16.128 16.128 0 0 0 3.584-21.312 144 144 0 1 1 265.92-75.392zM172.928 400.768a364.992 364.992 0 0 0-27.392 176.96c0.64 8.192 7.488 14.592 15.744 14.592 6.016 0.064 12.16 0.192 14.72 0.448a144 144 0 0 1-11.072 287.04A144.448 144.448 0 0 1 16.128 737.28a143.36 143.36 0 0 1 61.248-119.296 16 16 0 0 0 6.656-15.296A429.952 429.952 0 0 1 172.16 277.12a16.192 16.192 0 0 0-0.128-20.032l-24.896-30.72a4.032 4.032 0 0 1 2.56-6.464l94.464-14.976 68.992-11.008a4.032 4.032 0 0 1 4.416 5.376l-16.448 42.88-42.752 111.808a3.968 3.968 0 0 1-6.848 1.088l-16.96-20.992a15.872 15.872 0 0 0-25.536 0.896 360.064 360.064 0 0 0-36.16 65.856z"
                      :style="simplePauseFill"
                      p-id="4250"
                    /></svg>
                  </span>
                  <span v-if="jurisdiction.functions['kti']" title="激发" @click="onDoubleSpeed">
                    <svg
                      t="1632040559087"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="1346"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M848.738462 608.137846c-8.467692 178.097231-155.963077 319.881846-336.659693 319.881846-186.171077 0-337.132308-150.449231-337.132307-336.068923 0-180.145231 142.178462-327.168 320.787692-335.675077v159.82277l353.122461-192.039385L495.734154 0v160.098462C263.995077 168.684308 78.769231 358.754462 78.769231 591.872 78.769231 830.542769 272.777846 1024 512.157538 1024 746.062769 1024 936.644923 839.286154 945.230769 608.137846h-96.492307z"
                        p-id="1347"
                        :style="doubleSeedFill"
                      />
                    </svg>
                  </span>
                  <span v-if="jurisdiction.functions['sc']" title="循环" @click="onLoop">
                    <svg
                      t="1632040514192"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="1209"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M943.985778 740.579556a34.759111 34.759111 0 0 0-47.872 10.410666c-106.183111 164.522667-312.888889 241.550222-502.471111 187.306667C226.588444 890.538667 103.424 749.624889 75.377778 583.253333l131.299555 88.064a35.100444 35.100444 0 0 0 48.241778-9.159111 34.417778 34.417778 0 0 0-9.272889-47.758222L54.044444 485.944889a35.470222 35.470222 0 0 0-6.115555-3.299556 35.413333 35.413333 0 0 0-4.636445-1.393777c-0.568889-0.113778-1.137778-0.455111-1.848888-0.568889a34.503111 34.503111 0 0 0-6.826667-0.682667h-0.113778c-0.711111 0-1.393778 0.227556-2.076444 0.227556-1.507556 0.113778-3.128889 0.227556-4.636445 0.455111-1.052444 0.227556-1.991111 0.568889-3.015111 0.910222-1.137778 0.341333-2.417778 0.682667-3.584 1.137778-0.796444 0.369778-1.507556 0.824889-2.304 1.137777-1.28 0.711111-2.56 1.28-3.697778 2.076445-0.483556 0.341333-0.824889 0.682667-1.28 1.052444-1.393778 1.024-2.787556 2.048-3.925333 3.299556l-0.341333 0.455111c-1.28 1.393778-2.673778 2.759111-3.697778 4.352-4.067556 5.973333-5.916444 12.714667-5.916445 19.342222v0.142222c1.393778 225.507556 155.335111 426.894222 374.442667 489.528889 218.965333 62.606222 457.585778-26.225778 580.209778-216.263111a34.190222 34.190222 0 0 0-10.666667-47.274666zM1024 509.411556v-0.113778c-1.507556-225.393778-155.448889-426.666667-374.385778-489.415111C430.648889-42.723556 192.170667 46.108444 69.404444 236.088889a34.304 34.304 0 0 0 10.524445 47.502222 34.844444 34.844444 0 0 0 47.872-10.410667c106.325333-164.551111 312.888889-241.493333 502.471111-187.192888C797.297778 133.688889 920.462222 274.375111 948.593778 440.604444l-131.271111-88.064a34.929778 34.929778 0 0 0-48.128 9.159112 34.417778 34.417778 0 0 0 9.244444 47.758222l191.544889 128.455111s0.113778 0 0.113778 0.113778c1.848889 1.137778 3.697778 2.161778 5.774222 3.072 1.735111 0.711111 3.612444 1.28 5.461333 1.706666 0.455111 0.142222 0.910222 0.369778 1.365334 0.483556 2.332444 0.455111 4.522667 0.682667 6.826666 0.682667h0.113778c0.711111 0 1.422222-0.227556 2.104889-0.227556 1.479111-0.113778 2.986667-0.227556 4.494222-0.455111 1.052444-0.227556 1.991111-0.568889 3.015111-0.910222 1.137778-0.341333 2.417778-0.682667 3.584-1.137778 0.796444-0.369778 1.507556-0.824889 2.304-1.137778 1.28-0.711111 2.56-1.28 3.697778-2.076444 0.483556-0.341333 0.824889-0.682667 1.28-1.052445a27.306667 27.306667 0 0 0 3.925333-3.299555c0.113778-0.113778 0.227556-0.341333 0.369778-0.455111 1.251556-1.393778 2.645333-2.759111 3.697778-4.352 4.039111-6.087111 5.888-12.828444 5.888-19.484445z"
                        p-id="1210"
                        :style="loopFill"
                      />
                    </svg>
                  </span>
                  <span v-if="jurisdiction.functions['bv']" title="模糊视频" @click="onVideoBlur">
                    <svg
                      t="1632040892971"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9188"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M512 266.723556c-19.996444 0-39.196444 1.422222-57.628444 4.124444-23.324444 3.356444-45.056-12.088889-48.554667-34.531556-3.527111-22.442667 12.515556-43.377778 35.84-46.734222 22.613333-3.299556 46.08-5.034667 70.343111-5.034666 175.388444 0 303.36 91.022222 385.308444 177.777777a761.059556 761.059556 0 0 1 114.858667 159.175111c2.56 4.864 5.063111 9.756444 7.480889 14.705778l0.426667 0.938667 0.170666 0.341333v0.085334l0.028445 0.028444-38.968889 16.725333 39.025778 16.725334-0.085334 0.113777-0.085333 0.227556-0.341333 0.739556a624.355556 624.355556 0 0 1-22.613334 41.642666 770.389333 770.389333 0 0 1-67.84 96.227556 43.804444 43.804444 0 0 1-59.591111 6.144 40.078222 40.078222 0 0 1-7.196444-57.287111 686.478222 686.478222 0 0 0 71.168-104.533334 678.968889 678.968889 0 0 0-99.555556-136.675555C760.945778 340.053333 654.165333 266.723556 512 266.723556z m469.333333 287.601777l38.968889 16.725334a39.822222 39.822222 0 0 0 0-33.450667l-38.968889 16.725333zM186.965333 359.594667c8.391111 7.338667 13.368889 17.578667 13.909334 28.444444 0.512 10.894222-3.470222 21.532444-11.093334 29.582222a679.168 679.168 0 0 0-99.555555 136.704 679.367111 679.367111 0 0 0 99.555555 136.704C263.111111 768.568889 369.834667 841.927111 512 841.927111a394.808889 394.808889 0 0 0 134.4-23.239111c21.902222-7.395556 45.909333 3.470222 54.044444 24.405333 8.106667 20.935111-2.616889 44.259556-24.177777 52.536889A483.185778 483.185778 0 0 1 512 924.103111c-175.388444 0-303.36-91.022222-385.308444-177.777778a760.917333 760.917333 0 0 1-114.858667-159.175111c-2.56-4.835556-5.063111-9.756444-7.480889-14.705778l-0.426667-0.938666-0.170666-0.341334-0.028445-0.056888v-0.056889l38.968889-16.725334L3.640889 537.6l0.056889-0.028444 0.028444-0.085334 0.142222-0.341333 0.426667-0.938667 1.621333-3.185778c8.817778-17.464889 18.488889-34.531556 28.842667-51.171555a763.505778 763.505778 0 0 1 91.875556-119.523556 43.349333 43.349333 0 0 1 29.582222-13.368889c11.292444-0.540444 22.357333 3.299556 30.72 10.638223zM42.666667 554.325333L3.697778 537.6a39.822222 39.822222 0 0 0 0 33.450667l38.968889-16.725334z"
                        p-id="9189"
                        :style="vagueFill"
                      />
                      <path
                        d="M469.816889 364.544c0-22.784 19.000889-41.272889 42.439111-41.272889 128.113778 0 229.233778 104.391111 229.233778 229.916445 0 14.734222-8.106667 28.359111-21.219556 35.754666a43.52 43.52 0 0 1-42.467555 0 41.073778 41.073778 0 0 1-21.219556-35.754666c0-82.915556-66.133333-147.370667-144.327111-147.370667-23.438222 0-42.439111-18.488889-42.439111-41.272889z m-130.929778 107.008c22.926222 4.807111 37.489778 26.737778 32.568889 49.038222a151.04 151.04 0 0 0-3.527111 32.597334c0 82.915556 66.133333 147.370667 144.327111 147.370666 11.207111 0 22.072889-1.28 32.483556-3.697778 22.755556-5.376 45.710222 8.248889 51.2 30.407112 5.546667 22.158222-8.476444 44.458667-31.260445 49.806222a229.063111 229.063111 0 0 1-52.423111 5.973333c-128.113778 0-229.233778-104.391111-229.233778-229.916444 0-17.066667 1.877333-33.848889 5.432889-49.92 2.360889-10.695111 9.016889-20.053333 18.488889-25.998223 9.443556-5.973333 20.935111-7.992889 31.943111-5.688888v0.028444zM100.209778 111.303111a43.320889 43.320889 0 0 1 60.017778 0L924.302222 854.186667c16.099556 16.213333 15.872 41.955556-0.512 57.856a43.320889 43.320889 0 0 1-59.505778 0.512L100.209778 169.671111a40.476444 40.476444 0 0 1 0-58.368z"
                        p-id="9190"
                        :style="vagueFill"
                      />
                    </svg>
                  </span>
                  <span v-if="jurisdiction.functions['hts']" title="字幕" @click="onSubtitle">
                    <svg
                      v-if="!hideSubtitle"
                      t="1644291740024"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                    >
                      <path
                        d="M828.465335 900.361927h-81.522914l-26.171563-68.587544h-120.329025l-24.66745 68.587544h-79.717979l117.320799-300.822562h94.458285z m-136.272621-143.793184l-32.488836-87.238543-30.683902 86.93772z"
                        :style="{ fill: isScreenFill }"
                        p-id="3795"
                      />
                      <path
                        d="M300.822562 572.766157v360.987074a90.246769 90.246769 0 0 0 90.246768 90.246769h541.480611a90.246769 90.246769 0 0 0 90.246769-90.246769v-360.987074a90.246769 90.246769 0 0 0-90.246769-90.246768H391.06933a90.246769 90.246769 0 0 0-90.246768 90.246768z m601.645123 360.987074H421.151586a30.082256 30.082256 0 0 1-30.082256-30.082256v-300.822561a30.082256 30.082256 0 0 1 30.082256-30.082257h481.316099a30.082256 30.082256 0 0 1 30.082256 30.082257v300.822561a30.082256 30.082256 0 0 1-30.082256 30.082256zM631.426557 318.871915l-180.493537 120.329025a30.082256 30.082256 0 0 1-46.92832-24.968273v-240.658049a30.082256 30.082256 0 0 1 46.92832-24.968273l180.493537 120.329025a30.082256 30.082256 0 0 1 0 49.936545z"
                        :style="{ fill: isScreenFill }"
                        p-id="3796"
                      />
                      <path
                        d="M120.329025 572.766157a30.082256 30.082256 0 0 1-30.082256-30.082256v-421.151586a30.082256 30.082256 0 0 1 30.082256-30.082256h782.13866a30.082256 30.082256 0 0 1 30.082256 30.082256v270.740305h90.246769v-300.822561a90.246769 90.246769 0 0 0-90.246769-90.246769H90.246769a90.246769 90.246769 0 0 0-90.246769 90.246769v481.316098a90.246769 90.246769 0 0 0 90.246769 90.246769h120.329024v-90.246769z"
                        :style="{ fill: isScreenFill }"
                        p-id="3797"
                      />
                    </svg>
                    <svg
                      v-else
                      t="1644292180457"
                      viewBox="0 0 1036 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5410"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M400.747662 160.780805v240.87012a30.108765 30.108765 0 0 0 46.969673 25.291362l180.65259-120.43506a30.108765 30.108765 0 0 0 0-49.980549l-180.65259-120.43506a30.108765 30.108765 0 0 0-46.969673 24.689187z"
                        :style="{ fill: isScreenFill }"
                        p-id="5411"
                      />
                      <path
                        d="M90.326295 541.95777V120.43506a30.108765 30.108765 0 0 1 30.108765-30.108765h782.827889a30.108765 30.108765 0 0 1 30.108765 30.108765v270.978885h90.326295V90.326295a90.326295 90.326295 0 0 0-90.326295-90.326295H90.326295a90.326295 90.326295 0 0 0-90.326295 90.326295v481.740239a90.326295 90.326295 0 0 0 90.326295 90.326295h120.43506v-90.326295H120.43506a30.108765 30.108765 0 0 1-30.108765-30.108764z"
                        :style="{ fill: isScreenFill }"
                        p-id="5412"
                      />
                      <path
                        d="M1022.493658 946.017395a81.594753 81.594753 0 0 0 0-12.344593v-361.30518a90.326295 90.326295 0 0 0-90.326294-90.326295h-541.95777a88.519769 88.519769 0 0 0-55.701215 19.871785 43.958797 43.958797 0 0 0-30.108765 19.26961 45.464235 45.464235 0 0 0-3.010877 44.560972v367.929108a90.326295 90.326295 0 0 0 90.326295 90.326295h541.95777a90.326295 90.326295 0 0 0 34.323992-6.623929 45.163147 45.163147 0 0 0 54.797952-71.056685z m-90.326294-343.842096v283.624567l-150.543825-100.563276-74.067562-185.771079h-94.84261l-22.581574 58.109916L462.169542 572.066534h440.190144A30.108765 30.108765 0 0 1 933.371714 602.175299z m-283.022391 94.84261l9.935892-27.097888 16.559821 44.862059z m-258.935379 206.546128v-270.978885l165.899295 110.800255-60.21753 157.769929h79.788227l24.689188-68.647984h90.326294l40.947921 27.097888 15.656558 41.550096h46.367498l48.174024 31.915291h-421.52271a30.108765 30.108765 0 0 1-28.904414-29.50659z"
                        :style="{ fill: isScreenFill }"
                        p-id="5413"
                      />
                    </svg>
                  </span>
                  <el-dropdown v-if="jurisdiction.functions['mc']" @command="handleRateCommand">
                    <span
                      title="视频播放倍数"
                      class="speed-rate"
                      :style="{ color: isScreenFill }"
                    >{{ playbackRate }}x</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :disabled="playbackRate === 1.5" command="1.5">1.5x</el-dropdown-item>
                      <el-dropdown-item :disabled="playbackRate === 1.2" command="1.2">1.2x</el-dropdown-item>
                      <el-dropdown-item :disabled="playbackRate === 1" command="1">1x</el-dropdown-item>
                      <el-dropdown-item :disabled="playbackRate === 0.8" command="0.8">0.8x</el-dropdown-item>
                      <el-dropdown-item :disabled="playbackRate === 0.5" command="0.5">0.5x</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span v-if="jurisdiction.functions['fs']" title="全屏" @click="onFullscreen">
                    <svg
                      t="1632041196186"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="10154"
                      width="200"
                      height="200"
                      class="fullscreen"
                    >
                      <path
                        d="M398.1824 625.8176c12.288 12.288 13.4144 31.4368 3.3792 45.0048l-3.3792 3.84-217.4976 217.4976H263.168c17.5104 0 31.9488 13.0048 34.2528 29.8496l0.3072 4.7104a34.56 34.56 0 0 1-29.8496 34.2528l-4.7104 0.3072H97.28a34.56 34.56 0 0 1-34.2528-29.8496l-0.3072-4.7104v-165.888a34.56 34.56 0 0 1 68.8128-4.7104l0.3072 4.7104v82.3808l217.4976-217.3952a34.56 34.56 0 0 1 48.8448 0z m272.64-3.3792l3.84 3.3792 217.4976 217.4464v-82.432c0-17.5104 13.0048-31.9488 29.8496-34.2528l4.7104-0.3072c17.5104 0 31.9488 13.0048 34.2528 29.8496l0.3072 4.7104v165.888a34.56 34.56 0 0 1-29.8496 34.2528l-4.7104 0.3072h-165.888a34.56 34.56 0 0 1-4.7104-68.8128l4.7104-0.3072h82.432l-217.4464-217.4976a34.56 34.56 0 0 1 45.0048-52.224zM263.168 62.72a34.56 34.56 0 0 1 4.7104 68.8128l-4.7104 0.3072H180.736l217.4464 217.4976a34.56 34.56 0 0 1-45.0048 52.224l-3.84-3.3792L131.84 180.736v82.432a34.56 34.56 0 0 1-29.8496 34.2528l-4.7104 0.3072a34.56 34.56 0 0 1-34.2528-29.8496l-0.3072-4.7104V97.28c0-17.5104 13.0048-31.9488 29.8496-34.2528l4.7104-0.3072h165.888z m663.552 0c17.5104 0 31.9488 13.0048 34.2528 29.8496l0.3072 4.7104v165.888a34.56 34.56 0 0 1-68.8128 4.7104l-0.3072-4.7104V180.6848l-217.4976 217.4976a34.56 34.56 0 0 1-52.224-45.0048l3.3792-3.84 217.3952-217.4976H760.832a34.56 34.56 0 0 1-34.2528-29.8496l-0.3072-4.7104c0-17.5104 13.0048-31.9488 29.8496-34.2528l4.7104-0.3072h165.888z"
                        p-id="10155"
                        :style="{ fill: isScreenFill }"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <!-- 进度条 -->
              <div class="progress">
                <el-tooltip
                  effect="dark"
                  placement="top-start"
                  :value="continuePlay"
                  :manual="true"
                >
                  <div slot="content">
                    {{ secondToTimeStr(parseInt(continuePlayTime / 1000)) }}是否继续播放？({{ continuePlayCountdown }}s)
                    <el-button type="success" circle @click.stop="onContinuePlay">是</el-button>
                    <el-button type="danger" circle @click.stop="continuePlay=false">否</el-button>
                  </div>
                  <span class="start-time">{{ secondToTimeStr(currentTime) }}</span>
                </el-tooltip>
                <el-slider
                  v-model="percentage"
                  :range="percentageRange"
                  :format-tooltip="handleProgressFormatTooltip"
                  class="progress-bar"
                  @change="handlePercentageChange"
                />
                <span class="end-time">{{ secondToTimeStr(duration) }}</span>
              </div>
            </div>
          </div>
          <!-- 收缩栏 -->
          <!-- <div
            v-if="!isScreen"
            class="cont"
            @click.stop="isContraction=!isContraction; asideWidth=!isContraction?0:300"
          >
            <div class="cont-but">
              <i v-if="isContraction" class="el-icon-arrow-left"></i>
              <i v-else class="el-icon-arrow-right"></i>
            </div>
          </div> -->

          <!-- 挖空列表 -->
          <div class="hollow-div row" :class="{'hollow-div-screen':isScreen}" :style="{width:!isOpenHollow?'40px':'80%'}" style="z-index: 100;">
            <div class="row" style="width: 100%; height: 100%;">
              <!-- 视频右侧菜单 -->
              <div class="column right-menu">
                <div v-if="jurisdiction.functions['ho']" class="column menu-hollow">
                  <div
                    class="column menu-hollow-but"
                    :class="{'menu-hollow-but-select':hollowType===1&&isOpenHollow}"
                    @click="dismantleHollow();isOpenHollow==true&&hollowType!=1?hollowType=1: isOpenHollow=!isOpenHollow;hollowType=1;"
                  >
                    <img v-if="hollowType===1&&isOpenHollow" src="../assets/images/player/挖空-1.png" />
                    <img v-else src="../assets/images/player/挖空.png" />
                    <label :class="{'text-not-select':hollowType!==1 || !isOpenHollow}">挖空</label>
                  </div>
                  <div
                    v-if="isOpenHollow"
                    class="column menu-hollow-but"
                    :class="{'menu-hollow-but-select':hollowType===2&&isOpenHollow}"
                    @click="hollowType=2;"
                  >
                    <img v-if="hollowType===2&&isOpenHollow" src="../assets/images/player/字幕-1.png" />
                    <img v-else src="../assets/images/player/字幕.png" />
                    <label :class="{'text-not-select':hollowType!==2}">字幕</label>
                  </div>
                  <div
                    v-if="isOpenHollow"
                    class="column menu-hollow-but"
                    :class="{'menu-hollow-but-select':hollowType===3&&isOpenHollow}"
                    @click="hollowType=3;"
                  >
                    <img v-if="hollowType===3&&isOpenHollow" src="../assets/images/player/翻转-1.png" />
                    <img v-else src="../assets/images/player/翻转.png" />
                    <label :class="{'text-not-select':hollowType!==3}">翻转</label>
                  </div>
                </div>
                <!-- <div
                  v-if="!(addNoteHtmlIng || !isShowSubtitle)"
                  class="feedback-but"
                  @click="handleShowFeedbackDialog"
                >
                  <img src="../assets/images/player/反馈.png" />
                </div> -->
              </div>
              <el-scrollbar v-if="isOpenHollow" ref="hollowScrollbar" class="scrollbar" style="height: calc(100%);flex: 1;background: black;">
                <!-- 挖空 -->
                <div v-if="hollowType === 1">
                  <div
                    v-for="(subtit,index) in hollowList"
                    :key="index"
                    :ref="'hollowDiv' + index"
                    :class="{'hollow-subtit-play':(hollowIndex === index)}"
                    class="hollow-subtit row"
                    @mouseenter="subtit.isShowPlay=true;"
                    @mouseleave="subtit.isShowPlay=false;subtitleHollow(index);isHollowDown=false;"
                  >
                    <div style="width:18px;height:18px;margin-right:5px;">
                      <svg
                        v-if="subtit.isShowPlay"
                        t="1652849173710"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1962"
                        width="18"
                        height="18"
                        @click="onHollowPlay(subtit.startMillisecond,subtit.endMillisecond)"
                      >
                        <path
                          d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m196.546667 500.493333l-266.666667 176A37.333333 37.333333 0 0 1 384 688V336.033333a37.333333 37.333333 0 0 1 57.893333-31.16l266.666667 176a37.333333 37.333333 0 0 1 0 62.32z"
                          fill="#cdcdcd"
                          p-id="1963"
                        />
                      </svg>
                    </div>
                    <div v-for="(item, index1) in subtit.list" :key="index1">
                      <span
                        :class="{'hollow-hide':item.isSelect , 'hollow-hide-prominent': item.isProminent && item.isSelect}"
                        class="hollow-word"
                        :style="{fontSize: enFontSize + 'px'}"
                        @mouseover="onHollowMouseover(index,index1,item)"
                        @mouseleave="onHollowMouseleave(index,index1,item)"
                        @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                        @mouseup="subtitleHollow(index);isHollowDown=false;"
                      >{{ item.word }}</span>
                      <span
                        :class="{'hollow-hide-division':(item.isDivision &&
                          (index1 < subtit.list.length-1 && subtit.list[index1 + 1].isSelect && subtit.list[index1 + 1].type === 2) &&
                          item.type === 2)}"
                        class="hollow-blank"
                        @mouseover="onHollowMouseover(index,index1,item)"
                        @mouseleave="onHollowMouseleave(index,index1,item)"
                        @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                        @mouseup="subtitleHollow(index);isHollowDown=false;"
                      >&nbsp;</span>
                    </div>
                  </div>
                </div>
                <!-- 不支持挖空 -->
                <div v-if="hollowType === 2">
                  <div
                    v-for="(subtit,index) in hollowList"
                    :key="index"
                    :ref="'hollowDiv' + index"
                    :class="{'hollow-subtit-play':(hollowIndex === index)}"
                    class="hollow-subtit row"
                    @mouseenter="subtit.isShowPlay=true;"
                    @mouseleave="subtit.isShowPlay=false;isHollowDown=false;"
                  >
                    <div style="width:18px;height:18px;margin-right:5px;">
                      <svg
                        v-if="subtit.isShowPlay"
                        t="1652849173710"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1962"
                        width="18"
                        height="18"
                        @click="onHollowPlay(subtit.startMillisecond,subtit.endMillisecond)"
                      >
                        <path
                          d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m196.546667 500.493333l-266.666667 176A37.333333 37.333333 0 0 1 384 688V336.033333a37.333333 37.333333 0 0 1 57.893333-31.16l266.666667 176a37.333333 37.333333 0 0 1 0 62.32z"
                          fill="#cdcdcd"
                          p-id="1963"
                        />
                      </svg>
                    </div>
                    <div v-for="(item, index1) in subtit.list" :key="index1">
                      <span class="hollow-word" :style="{fontSize: enFontSize + 'px'}">{{ item.word }}</span>
                      <span class="hollow-word">&nbsp;</span>
                    </div>
                  </div>
                </div>
                <!-- 挖空-翻转 -->
                <div v-if="hollowType === 3">
                  <div
                    v-for="(subtit,index) in hollowList"
                    :key="index"
                    :ref="'hollowDiv' + index"
                    :class="{'hollow-subtit-play':(hollowIndex === index)}"
                    class="hollow-subtit row"
                    @mouseenter="subtit.isShowPlay=true;"
                    @mouseleave="subtit.isShowPlay=false;subtitleHollow(index);isHollowDown=false;"
                  >
                    <div style="width:18px;height:18px;margin-right:5px;">
                      <svg
                        v-if="subtit.isShowPlay"
                        t="1652849173710"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="1962"
                        width="18"
                        height="18"
                        @click="onHollowPlay(subtit.startMillisecond,subtit.endMillisecond)"
                      >
                        <path
                          d="M512 42.666667C252.793333 42.666667 42.666667 252.793333 42.666667 512s210.126667 469.333333 469.333333 469.333333 469.333333-210.126667 469.333333-469.333333S771.206667 42.666667 512 42.666667z m196.546667 500.493333l-266.666667 176A37.333333 37.333333 0 0 1 384 688V336.033333a37.333333 37.333333 0 0 1 57.893333-31.16l266.666667 176a37.333333 37.333333 0 0 1 0 62.32z"
                          fill="#cdcdcd"
                          p-id="1963"
                        />
                      </svg>
                    </div>
                    <div v-for="(item, index1) in subtit.list" :key="index1">
                      <span
                        :class="{'hollow-hide':!item.isSelect, 'hollow-hide-prominent': item.isProminent && !item.isSelect}"
                        class="hollow-word"
                        :style="{fontSize: enFontSize + 'px'}"
                        @mouseover="onHollowMouseover(index,index1,item)"
                        @mouseleave="onHollowMouseleave(index,index1,item)"
                        @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                        @mouseup="subtitleHollow(index);isHollowDown=false;"
                      >{{ item.word }}</span>
                      <span
                        :class="{'hollow-hide-division':(!item.isDivision &&
                          (index1 < subtit.list.length-1 && !subtit.list[index1 + 1].isSelect) && subtit.list[index1 + 1].type === 2 &&
                          item.type === 2)}"
                        class="hollow-word"
                        @mouseover="onHollowMouseover(index,index1,item)"
                        @mouseleave="onHollowMouseleave(index,index1,item)"
                        @mousedown="isHollowDown=true;onHollowMousedown(index,index1,item);"
                        @mouseup="subtitleHollow(index);isHollowDown=false;"
                      >&nbsp;</span>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <!-- 新版联想视频 -->
        <div
          v-if="dialogAssociationVisible"
          class="note-div column"
          @click="handleAssociationClose"
        >
          <el-scrollbar class="scrollbar" style="width: 320px;" @click.stop>
            <!-- 视频 -->
            <div v-for="(av, ai) in avList" :key="ai" class="column note-video" @click.stop>
              <img :src="av.cover" />
              <div class="play" :title="playOrPauseTitle" @click="onSceneVideoOpen(av.url)">
                <svg
                  class="play-icon"
                  t="1632038826276"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="730"
                >
                  <path
                    d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                    p-id="731"
                    fill="#c61200"
                  />
                </svg>
              </div>
            </div>
            <!-- 笔记 -->
            <div v-for="(no,ni) in associationNotes" :key="ni" class="column note-row" @click.stop>
              <div class="row user">
                <el-avatar :size="30" :src="no.head" class="head" />
                <label class="name">{{ no.nickname }}</label>
                <label class="time">{{ no.time }}</label>
              </div>
              <span class="content" v-html="no.content"></span>
              <div class="control">
                <div class="row but">
                  <svg
                    v-if="no.isGood<=0"
                    t="1637903956649"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2679"
                    width="16"
                    height="16"
                    @click="onNoteGood(no.nid,no)"
                  >
                    <path
                      d="M621.674667 408.021333c16.618667-74.24 28.224-127.936 34.837333-161.194666C673.152 163.093333 629.941333 85.333333 544.298667 85.333333c-77.226667 0-116.010667 38.378667-138.88 115.093334l-0.586667 2.24c-13.728 62.058667-34.72 110.165333-62.506667 144.586666a158.261333 158.261333 0 0 1-119.733333 58.965334l-21.909333 0.469333C148.437333 407.808 106.666667 450.816 106.666667 503.498667V821.333333c0 64.8 52.106667 117.333333 116.394666 117.333334h412.522667c84.736 0 160.373333-53.568 189.12-133.92l85.696-239.584c21.802667-60.96-9.536-128.202667-70.005333-150.186667a115.552 115.552 0 0 0-39.488-6.954667H621.674667zM544.256 149.333333c39.253333 0 59.498667 36.48 49.888 84.928-7.573333 38.144-21.984 104.426667-43.221333 198.666667-4.512 20.021333 10.56 39.093333 30.912 39.093333h218.666666c6.101333 0 12.16 1.066667 17.909334 3.168 27.445333 9.984 41.674667 40.554667 31.776 68.266667l-85.568 239.573333C744.981333 838.026667 693.301333 874.666667 635.402667 874.666667H223.498667C194.314667 874.666667 170.666667 850.784 170.666667 821.333333V503.498667c0-17.866667 14.144-32.448 31.829333-32.821334l21.866667-0.469333a221.12 221.12 0 0 0 167.381333-82.56c34.346667-42.602667 59.146667-99.306667 74.869333-169.877333C482.101333 166.336 499.552 149.333333 544.266667 149.333333z"
                      p-id="2680"
                    />
                  </svg>
                  <svg
                    v-if="no.isGood>0"
                    t="1637903943317"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2500"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M621.674667 408.021333c16.618667-74.24 28.224-127.936 34.837333-161.194666C673.152 163.093333 629.941333 85.333333 544.298667 85.333333c-77.226667 0-116.010667 38.378667-138.88 115.093334l-0.586667 2.24c-13.728 62.058667-34.72 110.165333-62.506667 144.586666a158.261333 158.261333 0 0 1-119.733333 58.965334l-21.909333 0.469333C148.437333 407.808 106.666667 450.816 106.666667 503.498667V821.333333c0 64.8 52.106667 117.333333 116.394666 117.333334h412.522667c84.736 0 160.373333-53.568 189.12-133.92l85.696-239.584c21.802667-60.96-9.536-128.202667-70.005333-150.186667a115.552 115.552 0 0 0-39.488-6.954667H621.674667z"
                      p-id="2501"
                      fill="#c61200"
                    />
                  </svg>
                  <svg
                    t="1637904451494"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2826"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M157.568 751.296c-11.008-18.688-18.218667-31.221333-21.802667-37.909333A424.885333 424.885333 0 0 1 85.333333 512C85.333333 276.362667 276.362667 85.333333 512 85.333333s426.666667 191.029333 426.666667 426.666667-191.029333 426.666667-426.666667 426.666667a424.778667 424.778667 0 0 1-219.125333-60.501334 2786.56 2786.56 0 0 0-20.053334-11.765333l-104.405333 28.48c-23.893333 6.506667-45.802667-15.413333-39.285333-39.296l28.437333-104.288z m65.301333 3.786667l-17.258666 63.306666 63.306666-17.258666a32 32 0 0 1 24.522667 3.210666 4515.84 4515.84 0 0 1 32.352 18.944A360.789333 360.789333 0 0 0 512 874.666667c200.298667 0 362.666667-162.368 362.666667-362.666667S712.298667 149.333333 512 149.333333 149.333333 311.701333 149.333333 512c0 60.586667 14.848 118.954667 42.826667 171.136 3.712 6.912 12.928 22.826667 27.370667 47.232a32 32 0 0 1 3.338666 24.714667z m145.994667-70.773334a32 32 0 1 1 40.917333-49.205333A159.189333 159.189333 0 0 0 512 672c37.888 0 73.674667-13.173333 102.186667-36.885333a32 32 0 0 1 40.917333 49.216A223.178667 223.178667 0 0 1 512 736a223.178667 223.178667 0 0 1-143.136-51.690667z"
                      p-id="2827"
                      fill="#707070"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </el-main>
      <!-- 播放列表/笔记列表 -->
      <el-aside
        v-if="!isScreen && videoVideoList.length>0"
        class="aside"
        :style="{width:asideWidth+'px'}"
        style="background: #F1F1F1;"
      >
        <div class="tabs" @mouseenter="onLeftMouseEnter()" @mouseleave="onLeftMouseLeave()">
          <div v-if="isContraction" class="tabs-top" style="padding: 10px;">
            <div style="background: white;width: 100%; border-radius: 5px;" class="row">
              <div
                class="item"
                :class="{ 'is-active': activeName === 'list' }"
                @click="handleTabClick('list')"
              >播放</div>
              <div
                class="item"
                :class="{ 'is-active': activeName === 'note' }"
                @click="handleTabClick('note')"
              >笔记</div>
            </div>
          </div>
          <div v-if="activeName === 'list' && isContraction" class="tabs-content">
            <div class="list">
              <el-scrollbar ref="videoScrollbar" class="scrollbar">
                <template v-if="videoVideoList.length === 0">
                  <el-empty description="暂无符合条件的网络视频" />
                </template>
                <div
                  v-for="(video, index) in videoVideoList"
                  :id="'vid'+video.vid"
                  :key="index"
                  :class="{ 'is-active': video.vid === videoId }"
                  class="card"
                  @click="handleLoadVideo(video.vid, index)"
                >
                  <div class="card-header frame" style="background: white; border-radius: 4px;border: 2px white solid;">
                    <div class="thumb">
                      <el-image fit="cover" :src="video.cover" lazy>
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                        <div slot="placeholder" class="image-slot">
                          <i class="el-icon-loading"></i>
                        </div>
                      </el-image>
                      <svg
                        t="1632038826276"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="730"
                        style="position: absolute;left: 50px;width: 60px;top: 26px;"
                      >
                        <path
                          class="paly"
                          d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                          p-id="731"
                          fill="transparent"
                        />
                      </svg>
                    </div>
                    <div class="content">
                      <div class="title">{{ video.name }}</div>
                      <div class="time">
                        <i class="el-icon-view"></i>
                        {{ secondToTimeStr(video.learningTime) }}
                        <el-divider direction="vertical" />
                        <i class="el-icon-time"></i>
                        {{ secondToTimeStr(parseInt(video.lastTime / 1000)) }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div class="operation">
              <div class="open" title="单集循环" @click="onPlayMode('1')">
                <!-- <input
                  id="sourceFile"
                  ref="localFileInput"
                  multiple="false"
                  accept="*.mp4"
                  type="file"
                  style="display: none"
                  @change="handleFileChange"
                />-->
                <i
                  class="el-icon-refresh-left"
                  :style="{color:playMode==1?'#c61200':'#b9b4b4'}"
                  style="width: 20px; height: 20px; "
                ></i>
              </div>
              <div title="顺序播放" class="refresh" @click="onPlayMode('2')">
                <i
                  class="el-icon-bottom"
                  :style="{color:playMode==2?'#c61200':'#b9b4b4'}"
                  style="width: 20px; height: 20px; "
                ></i>
              </div>
              <div title="列表循环" class="del" @click="onPlayMode('3')">
                <i
                  class="el-icon-sort"
                  :style="{color:playMode==3?'#c61200':'#b9b4b4'}"
                  style="width: 20px; height: 20px; "
                ></i>
              </div>
            </div>
          </div>
          <!--笔记-->
          <div v-if="activeName === 'note'&& isContraction" class="tabs-content">
            <div class="note">
              <el-scrollbar class="scrollbar">
                <template v-if="noteList.length === 0">
                  <el-empty description="暂无符合条件的笔记列表" />
                </template>
                <div
                  v-for="(item, index) in noteList"
                  :key="index"
                  class="row column"
                  @click.stop="onNote(item.startMillisecond)"
                >
                  <el-image fit="cover" :src="item.screen" class="img" lazy>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    <div slot="placeholder" class="image-slot">
                      <i class="el-icon-loading"></i>
                    </div>
                  </el-image>
                  <div class="en">
                    <span v-html="item.english"></span>
                  </div>
                  <div class="zh">{{ item.content }}</div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </el-aside>
    </el-container>
    <!--添加笔记-->
    <el-dialog
      title="添加笔记"
      :visible.sync="dialogAddNoteVisible"
      width="710px"
      class="dialogAddNote"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleAddNoteClose"
    >
      <div class="screen">
        <el-image fit="cover" :src="'data:image/png;base64,' + addNoteForm.screen" lazy>
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
          <div slot="placeholder" class="image-slot">
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <div class="subtitle">
          <div class="en" v-html="currentSubtitle"></div>
          <div class="zh">{{ currentSubtitleZh }}</div>
        </div>
      </div>
      <el-input
        v-model="addNoteForm.content"
        type="textarea"
        :rows="2"
        maxlength="100"
        show-word-limit
        placeholder="请输入笔记内容，最多可填写100个字符"
      />
      <span slot="footer">
        <el-button @click="dialogAddNoteVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="addNoteIng"
          :disabled="addNoteIng"
          @click="onSubmitAddNote()"
        >提交</el-button>
      </span>
    </el-dialog>
    <!--问题反馈-->
    <el-dialog
      title="问题反馈"
      :visible.sync="dialogfeedbackVisible"
      width="710px"
      class="dialogAddNote"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleFeedbackClose"
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="问题类型">
          <el-radio v-model="feedbackForm.type" label="1">字幕翻译不准确</el-radio>
          <el-radio v-model="feedbackForm.type" label="2">字幕时间不正确</el-radio>
          <el-radio v-model="feedbackForm.type" label="3">无法显示图像</el-radio>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="feedbackForm.content"
            type="textarea"
            :rows="2"
            maxlength="400"
            show-word-limit
            placeholder="请您的描述控制在400字以内，谢谢~您的宝贵意见"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogfeedbackVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="addFeedbackIng"
          :disabled="addFeedbackIng"
          @click="onSubmitFeedback()"
        >提交</el-button>
      </span>
    </el-dialog>
    <!-- 联想视频、情景视频 -->
    <div v-if="sceneVideoOpen" class="scene-video-popup">
      <div class="video column">
        <video
          id="sceneVideo"
          ref="sceneVideo"
          oncontextmenu="return false;"
          style="outline: none;"
          :src="sceneVideoUrl"
          controlslist="nodownload"
          :disablePictureInPicture="true"
          controls
          autoplay
          @click.left="onsSceneVideoClickLeft"
        ></video>
        <div class="control" style="display:none;">
          <div class="row control-but">
            <div class="play" :title="playOrPauseTitle" @click="onScene">
              <svg
                v-if="!sceneVideoPayState"
                class="play-icon"
                t="1632038826276"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="730"
              >
                <path
                  d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                  p-id="731"
                  fill="white"
                />
              </svg>
              <svg
                v-else
                t="1632066311123"
                class="pause-icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2390"
              >
                <path
                  :style="{ fill: 'white' }"
                  d="M142.222222 0m99.555556 0l0 0q99.555556 0 99.555555 99.555556l0 824.888888q0 99.555556-99.555555 99.555556l0 0q-99.555556 0-99.555556-99.555556l0-824.888888q0-99.555556 99.555556-99.555556Z"
                  p-id="2391"
                />
                <path
                  d="M682.666667 0m99.555555 0l0 0q99.555556 0 99.555556 99.555556l0 824.888888q0 99.555556-99.555556 99.555556l0 0q-99.555556 0-99.555555-99.555556l0-824.888888q0-99.555556 99.555555-99.555556Z"
                  :style="{ fill: 'white' }"
                  p-id="2392"
                />
              </svg>
            </div>
            <!-- <span title="下一句" @click="onNextSentence">
              <svg
                t="1632040345330"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="996"
                width="16"
                height="16"
              >
                <path
                  d="M967.11117 0.000284c-11.320879 0-22.186648 3.839997-30.151086 10.723547a34.133305 34.133305 0 0 0-12.515545 25.855979v950.840096c0 20.195539 19.114651 36.579525 42.666631 36.579525s42.666631-16.383986 42.666631-36.579525V36.57981C1009.777801 16.384271 990.663151 0.000284 967.11117 0.000284zM50.205268 9.500721A73.41505 73.41505 0 0 0 14.223076 73.159335v877.681046a73.41505 73.41505 0 0 0 35.982192 63.658614 69.290609 69.290609 0 0 0 71.594607-0.938666l711.195852-438.840523v0.028444A73.585716 73.585716 0 0 0 867.555698 512.028302c0-25.713756-13.112878-49.521737-34.559971-62.748392L121.799875 10.439387A69.290609 69.290609 0 0 0 50.205268 9.500721z"
                  p-id="997"
                  :style="{ fill: 'white' }"
                />
              </svg>
            </span>-->
          </div>
        </div>
        <div
          class="close"
          @click="sceneVideoOpen=false;$refs.sceneVideo.pause(); sceneVideoPayState=false;isSceneVideoTooltip = true;sceneVideoUrl='';"
        >
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
    <!-- 新有道翻译 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="dialogDictionaryVisible"
      :close-on-click-modal="true"
      width="75%"
      style="max-height: 90%;"
      @close="handleDictionaryClose"
    >
      <div slot="title" class="row" style="width:100%">
        <el-input
          v-model="youdaoTitel"
          placeholder="请输入查询的词"
          @focus="onSelectWordFocus"
          @blur="onSelectWordBlur"
          @keyup.enter.native="onSelectWordEnter"
        >
          <el-button
            v-if="ModelSentenceWordList.length>1"
            slot="prepend"
            icon="el-icon-back"
            @click="onMSBack()"
          />
          <el-button slot="append" @click="onCollect">
            <img
              v-if="!isCollect"
              src="../assets/images/player/未收藏.png"
              style="width: 15px;margin-top: 5px;"
            />
            <img
              v-else
              src="../assets/images/player/已收藏.png"
              style="width: 15px;margin-top: 5px;"
            />
          </el-button>
        </el-input>
        <el-button-group style="width:800px;margin-left: 10px;margin-right: 30px;">
          <el-button
            type="success"
            icon="el-icon-search"
            @click="onSelectWordEnter"
          >查词</el-button>
          <el-button
            v-if="jurisdiction.functions['ess']"
            type="primary"
            icon="el-icon-tickets"
            @click="onModelSentence"
          >例句</el-button>
          <el-button
            v-if="jurisdiction.functions['qjsp']"
            icon="el-icon-tickets"
            @click="onSceneVideo"
          >情景视频</el-button>
          <el-button
            v-if="jurisdiction.functions['aiqjsp']"
            icon="el-icon-tickets"
            @click="onAiSceneVideo"
          >Ai情景视频(内测版)</el-button>
        </el-button-group>
      </div>
      <el-scrollbar
        style="width:100%;height:100%;"
      >
        <!-- 有道翻译 -->
        <div v-if="isModelSentence==1" class="column" style="min-height: 140px;">
          <div class="row">
            <el-button :loading="aiExplainLogin" @click="htmlType=0;">Ai</el-button>
            <el-button @click="htmlType=2;">中文</el-button>
            <el-button v-if="meiYinVideo!=null" @click="htmlType=3;">发音</el-button>
            <el-button :loading="klsLoading" @click="htmlType=1;onKls()">英英</el-button>
            <el-select v-model="htmlType" style="margin-left: 10px;" @change="onHtmlType">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div v-if="htmlType==0" :style="{fontSize: youdaoTextSize+12 +'px'}" style="margin-top:10px;">
            <div v-html="aiExplainText"></div>
            <div style="background: black;position: absolute;right: 0px;padding: 14px 0px;border-radius: 10px;top:10px;">
              <el-slider v-model="youdaoTextSize" :max="20" :vertical="true" height="100px" @change="onYoudaoTextSize" />
            </div>
          </div>
          <div v-if="htmlType===2" class="column" style="margin-top:10px;">
            <div style="background: black;position: absolute;right: 0px;padding: 14px 0px;border-radius: 10px;top:10px;">
              <el-slider v-model="youdaoTextSize" :max="20" :vertical="true" height="100px" @change="onYoudaoTextSize" />
            </div>
            <!-- 单词 -->
            <div v-if="translate.dict">
              <!-- 原语言 -->
              <div class="row vertical-center">
                <span v-if="translate.dict.base" style="font-weight: bold;margin-left:5px; margin-right: 10px;" :style="{fontSize: youdaoTextSize+ 24 +'px'}">{{ translate.dict.base.word }}</span>
                <svg t="1714106921932" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4348" width="14" height="14" @click="onKeLinShiAudio(translate.dict.base.pronounce)"><path d="M148.00896 365.010944l0 0.41984c-1.527808-0.256-3.084288-0.421888-4.685824-0.421888L53.37088 365.008896c-15.525888 0-28.110848 12.58496-28.110848 28.110848l0 264.2432c0 15.521792 12.587008 28.110848 28.110848 28.110848l89.952256 0c1.599488 0 3.158016-0.16384 4.685824-0.421888l0 0.41984 327.95648 227.69664L475.96544 131.692544 148.00896 365.010944z" fill="#222222" p-id="4349" /><path d="M654.938112 185.229312l0 33.755136c170.579968 4.95616 307.339264 144.78336 307.339264 316.563456 0 171.782144-136.759296 311.605248-307.339264 316.565504l0 33.75104c189.210624-4.9664 341.07392-159.905792 341.07392-350.318592S844.148736 190.19776 654.938112 185.229312z" fill="#222222" p-id="4350" /><path d="M624.664576 308.789248l0 21.848064c110.41792 3.209216 198.940672 93.71648 198.940672 204.910592 0 111.192064-88.522752 201.701376-198.940672 204.910592l0 21.85216c122.476544-3.213312 220.7744-103.50592 220.7744-226.762752C845.438976 412.295168 747.139072 312.004608 624.664576 308.789248z" fill="#222222" p-id="4351" /><path d="M576.223232 395.034624l0 13.53728c68.421632 1.990656 123.275264 58.073088 123.275264 126.976s-54.853632 124.987392-123.275264 126.976l0 13.539328c75.894784-1.994752 136.808448-64.141312 136.808448-140.515328S652.118016 397.02528 576.223232 395.034624z" fill="#222222" p-id="4352" /></svg>
              </div>
              <!-- 英标 -->
              <div class="row" style="margin-top: 10px;">
                <span v-if="translate.dict.base.pron_am" style="background: #eaeaea;padding: 5px 15px;border-radius: 20px;margin-right: 10px;" :style="{fontSize: youdaoTextSize +12 +'px'}">英[{{ translate.dict.base.pron_am.text }}]
                  <svg t="1714106921932" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4348" width="14" height="14" @click="aliPay('olivia')"><path d="M148.00896 365.010944l0 0.41984c-1.527808-0.256-3.084288-0.421888-4.685824-0.421888L53.37088 365.008896c-15.525888 0-28.110848 12.58496-28.110848 28.110848l0 264.2432c0 15.521792 12.587008 28.110848 28.110848 28.110848l89.952256 0c1.599488 0 3.158016-0.16384 4.685824-0.421888l0 0.41984 327.95648 227.69664L475.96544 131.692544 148.00896 365.010944z" fill="#222222" p-id="4349" /><path d="M654.938112 185.229312l0 33.755136c170.579968 4.95616 307.339264 144.78336 307.339264 316.563456 0 171.782144-136.759296 311.605248-307.339264 316.565504l0 33.75104c189.210624-4.9664 341.07392-159.905792 341.07392-350.318592S844.148736 190.19776 654.938112 185.229312z" fill="#222222" p-id="4350" /><path d="M624.664576 308.789248l0 21.848064c110.41792 3.209216 198.940672 93.71648 198.940672 204.910592 0 111.192064-88.522752 201.701376-198.940672 204.910592l0 21.85216c122.476544-3.213312 220.7744-103.50592 220.7744-226.762752C845.438976 412.295168 747.139072 312.004608 624.664576 308.789248z" fill="#222222" p-id="4351" /><path d="M576.223232 395.034624l0 13.53728c68.421632 1.990656 123.275264 58.073088 123.275264 126.976s-54.853632 124.987392-123.275264 126.976l0 13.539328c75.894784-1.994752 136.808448-64.141312 136.808448-140.515328S652.118016 397.02528 576.223232 395.034624z" fill="#222222" p-id="4352" /></svg>
                </span>
                <span v-if="translate.dict.base.pron_en" style="background: #eaeaea;padding: 5px 15px;border-radius: 20px;" :style="{fontSize: youdaoTextSize+12 +'px'}">美[{{ translate.dict.base.pron_en.text }}]
                  <svg t="1714106921932" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4348" width="14" height="14" @click="aliPay('cindy')"><path d="M148.00896 365.010944l0 0.41984c-1.527808-0.256-3.084288-0.421888-4.685824-0.421888L53.37088 365.008896c-15.525888 0-28.110848 12.58496-28.110848 28.110848l0 264.2432c0 15.521792 12.587008 28.110848 28.110848 28.110848l89.952256 0c1.599488 0 3.158016-0.16384 4.685824-0.421888l0 0.41984 327.95648 227.69664L475.96544 131.692544 148.00896 365.010944z" fill="#222222" p-id="4349" /><path d="M654.938112 185.229312l0 33.755136c170.579968 4.95616 307.339264 144.78336 307.339264 316.563456 0 171.782144-136.759296 311.605248-307.339264 316.565504l0 33.75104c189.210624-4.9664 341.07392-159.905792 341.07392-350.318592S844.148736 190.19776 654.938112 185.229312z" fill="#222222" p-id="4350" /><path d="M624.664576 308.789248l0 21.848064c110.41792 3.209216 198.940672 93.71648 198.940672 204.910592 0 111.192064-88.522752 201.701376-198.940672 204.910592l0 21.85216c122.476544-3.213312 220.7744-103.50592 220.7744-226.762752C845.438976 412.295168 747.139072 312.004608 624.664576 308.789248z" fill="#222222" p-id="4351" /><path d="M576.223232 395.034624l0 13.53728c68.421632 1.990656 123.275264 58.073088 123.275264 126.976s-54.853632 124.987392-123.275264 126.976l0 13.539328c75.894784-1.994752 136.808448-64.141312 136.808448-140.515328S652.118016 397.02528 576.223232 395.034624z" fill="#222222" p-id="4352" /></svg>
                </span>
              </div>
              <!-- 释义 -->
              <div class="column" style="margin-top: 15px;">
                <span style="font-weight: bold;margin-top: 5px;" :style="{fontSize: youdaoTextSize+16 +'px'}">释义</span>
                <div class="column" style="margin-top: 5px" :style="{fontSize: youdaoTextSize+14 +'px'}">
                  <div v-for="(item, index) in translate.dict.base.explain.word_means" :key="index">
                    <span style="color: #909399;">{{ item.part }} </span>
                    <span v-for="(m, mi) in item.means" :key="mi" style="margin-left: 10px;">{{ m }} </span>
                  </div>
                </div>
              </div>
              <!-- 词态变化 -->
              <div v-if="translate.dict.base.exchange.word_done" class="column" style="margin-top: 15px;">
                <span style="font-weight: bold;margin-top: 5px;" :style="{fontSize: youdaoTextSize+16 +'px'}">词态变化</span>
                <div class="row" style="margin-top: 5px" :style="{fontSize: youdaoTextSize+14 +'px'}">
                  <div v-if="translate.dict.base.exchange.word_done.length>0" style="margin-right: 10px;">
                    <span style="color: #909399;">过去分词:</span>
                    <span v-for="(m, mi) in translate.dict.base.exchange.word_done" :key="mi">{{ m }} </span>
                  </div>
                  <div v-if="translate.dict.base.exchange.word_ing.length>0" style="margin-right: 10px;">
                    <span style="color: #909399;">现代分词:</span>
                    <span v-for="(m, mi) in translate.dict.base.exchange.word_ing" :key="mi">{{ m }} </span>
                  </div>
                  <div v-if="translate.dict.base.exchange.word_past.length>0" style="margin-right: 10px;">
                    <span style="color: #909399;">过去式:</span>
                    <span v-for="(m, mi) in translate.dict.base.exchange.word_past" :key="mi">{{ m }} </span>
                  </div>
                  <div v-if="translate.dict.base.exchange.word_pl.length>0" style="margin-right: 10px;">
                    <span style="color: #909399;">复数:</span>
                    <span v-for="(m, mi) in translate.dict.base.exchange.word_pl" :key="mi">{{ m }} </span>
                  </div>
                  <div v-if="translate.dict.base.exchange.word_third.length>0" style="margin-right: 10px;">
                    <span style="color: #909399;">第三人称单数:</span>
                    <span v-for="(m, mi) in translate.dict.base.exchange.word_third" :key="mi">{{ m }} </span>
                  </div>
                </div>
              </div>
              <!-- 真题例句 -->
              <div class="column" style="margin-top: 15px;">
                <span style="font-weight: bold;margin-top: 5px;" :style="{fontSize: youdaoTextSize+16 +'px'}">真题例句</span>
                <div v-for="(ts, tsi) in translate.dict.true_sentences" :key="tsi">
                  <div v-for="(sentences, si) in ts.sentences" :key="si" class="column" style="margin-bottom: 10px;">
                    <span :style="{fontSize: youdaoTextSize+14 +'px'}">{{ sentences.text }}</span>
                    <span style="color: #909399;" :style="{fontSize: youdaoTextSize+12 +'px'}">{{ sentences.source }}</span>
                  </div>
                </div>
              </div>
              <!-- 同义词 -->
              <div class="column" style="margin-top: 15px;">
                <span style="font-weight: bold;margin-top: 5px;" :style="{fontSize: youdaoTextSize+16 +'px'}">同义词</span>
                <div v-for="(s, si) in translate.dict.synonym" :key="si" class="column" style="margin-top: 5px;">
                  <div v-for="(wm, wmi) in s.word_means" :key="wmi" class="column" style="margin-bottom: 10px;">
                    <div>
                      <span style="font-weight: bold;" :style="{fontSize: youdaoTextSize+14 +'px'}">{{ s.part }}</span>
                      <span style="font-weight: bold;" :style="{fontSize: youdaoTextSize+14 +'px'}">{{ wm.mean }}</span>
                    </div>
                    <div class="row" style="flex-wrap: wrap;"><span v-for="(w,wi) in wm.words" :key="wi" style="margin-right:10px;" :style="{fontSize: youdaoTextSize+12 +'px'}">{{ w }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文本翻译 -->
            <div v-if="translate.transResult">
              <span style="font-weight: bold;margin-left:5px; margin-right: 10px;" :style="{fontSize: youdaoTextSize+ 18 +'px'}">{{ translate.transResult }}</span>
            </div>
          </div>
          <div v-if="htmlType===3" style="margin-top:10px;">
            <video
              id="sceneVideo"
              ref="sceneVideo"
              oncontextmenu="return false;"
              style="outline: none;width: 100%;height: 100%;border-radius: 6px;"
              :src="meiYinVideo"
              controlslist="nodownload"
              controls
              @click.left="onsSceneVideoClickLeft"
              @timeupdate="onTimeupdate"
            ></video>
          </div>
          <div v-if="htmlType===1" style="margin-top:10px;" v-html="klsHtml"></div>
        </div>
        <!-- 例句 -->
        <div v-if="isModelSentence==2">
          <div
            v-if="msLogin"
            style="font-size: 10px;color: #777;margin: 20px 0px;"
          >检索例句中...</div>
          <el-scrollbar
            v-else
            class="scrollbar"
            style="height: 100%;width: 100%;"
          >
            <div style="background: black;position: absolute;right: 0px;padding: 14px 0px;border-radius: 10px;top:10px;">
              <el-slider v-model="youdaoTextSize" :max="20" :vertical="true" height="100px" @change="onYoudaoTextSize" />
            </div>
            <div
              v-for="(item, index) in PageModelSentenceList"
              :key="index"
              class="column ms-row"
              style="cursor:pointer;"
              @click.stop="osMSOpacity(PageModelSentenceIndex*20+ index)"
            >
              <span class="ms-english">
                <span>{{ PageModelSentenceIndex*20+ index+1 }}.</span>
                <div
                  v-if="((item.frequency0>0 || item.frequency1>0) && item.frequency2==0 && item.frequency3==0 && item.frequency4==0 && item.frequency5==0)"
                  class="frequency"
                  style="background: #EEA531;"
                >初级</div>
                <div
                  v-if="((item.frequency0>0 || item.frequency1>0 ) && item.frequency2>0 && item.frequency3==0 && item.frequency4==0 && item.frequency5==0)"
                  class="frequency"
                  style="background: #3D8D2B;"
                >初中级</div>
                <div
                  v-if="((item.frequency2>0 || item.frequency3>0) && item.frequency4==0 && item.frequency5==0)"
                  class="frequency"
                  style="background: #2FA2D2;"
                >中级</div>
                <div
                  v-if="((item.frequency2>0 || item.frequency3>0 ) && item.frequency4>0 && item.frequency5==0)"
                  class="frequency"
                  style="background: #2E63C3;"
                >中高级</div>
                <div
                  v-if="((item.frequency4>0 || item.frequency5>0))"
                  class="frequency"
                  style="background: #9D24B3;"
                >高级</div>
                <span
                  style="max-width: 580px;-webkit-touch-callout: text;-webkit-user-select: text; -khtml-user-select: text; -moz-user-select: text; -ms-user-select: text; user-select: text;margin-left: 5px;"
                  :style="{fontSize: youdaoTextSize+18 +'px'}"
                  v-html="item.english"
                ></span>
                <div
                  class="play"
                  style="background: #5961cd;margin-left: 20px;"
                  @click.stop="onMsPlay(1,item.englishText)"
                >
                  <img src="../assets/images/home/播放按钮.png" />
                </div>
                <div
                  class="play"
                  style="background: #B62B1A;margin-left: 10px;"
                  @click.stop="onMsPlay(2,item)"
                >
                  <img src="../assets/images/home/播放按钮.png" />
                </div>
                <i
                  v-if="item.isMsLoading"
                  class="el-icon-loading"
                  style="margin-left:5px;"
                ></i>
              </span>
              <span class="ms-chinese">
                <div v-if="item.chinese=='' || item.chinese== null" style=" display: flex;align-items: center;" :style="{fontSize: youdaoTextSize+12 +'px'}">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4077" width="24" height="24" @click.stop="onTranslation(item)"><path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m100.266667 419.114667h-67.456v31.786667h-105.984v53.973333h105.984v34.688h-116.565334v53.930667h116.565334v79.018666h67.413333V678.826667h127.146667v-53.930667h-127.146667v-34.688h116.608v-53.973333h-116.608v-31.786667z m-233.642667-62.634667H273.152v62.634667h40.96v160.853333c0 17.109333-3.669333 29.866667-10.965333 38.314667l-2.090667 2.176 34.688 47.232c21.504-22.485333 50.773333-47.701333 87.68-75.648-3.84-26.325333-5.973333-51.84-6.272-76.586667a368.128 368.128 0 0 1-31.317333 29.226667l-7.210667 5.973333v-194.133333z m351.146667-139.690666h-298.666667v53.504h54.186667l-37.290667 20.224c19.584 24.874667 39.808 45.738667 60.672 62.592a587.52 587.52 0 0 1-105.002667 24.106666c13.141333 19.626667 23.594667 38.528 31.317334 56.832 50.56-8.533333 96.469333-22.186667 137.770666-40.96 36.437333 16.725333 87.168 29.568 152.192 38.570667l5.418667-13.354667c5.717333-13.909333 12.373333-29.525333 20.138667-46.890666-40.149333-2.56-76.202667-8.661333-108.16-18.304a403.712 403.712 0 0 0 80.512-75.093334l6.912-8.704v-52.48z m-85.76 53.504a279.04 279.04 0 0 1-68.608 53.205333A324.010667 324.010667 0 0 1 516.394667 362.666667l-6.997334-6.997334h134.656zM334.848 283.306667l-48.64 38.058666c23.424 29.226667 45.738667 58.112 66.944 86.698667 18.304-14.421333 36.608-28.416 54.912-41.898667a2357.845333 2357.845333 0 0 0-65.706667-74.666666l-7.509333-8.192z" fill="#000000" p-id="4078" /></svg>
                  <span v-html="item.tempHtml"></span>
                </div>
                <span v-else :style="{fontSize: youdaoTextSize+12 +'px'}" v-html="item.chinese"></span>
              </span>
              <span class="ms-provenance" :style="{fontSize: youdaoTextSize+10 +'px'}">来自:{{ item.grouping }}({{ item.name }})</span>
            </div>
          </el-scrollbar>
          <div
            v-if="ModelSentenceList.length>0"
            class="row"
            style="position:absolute;bottom: 20px;right: 0px;font-size: 12px;z-index: 9999;"
          >
            <label
              v-if="ModelSentenceList.length>=1"
              :style="{'font-weight':PageModelSentenceIndex===0 ? 'bold' : ''}"
              style="cursor:pointer;"
              @click="onModelSentenceListPage(1)"
            >&nbsp;第1页&nbsp;</label>
            <label
              v-if="ModelSentenceList.length>=20"
              :style="{'font-weight':PageModelSentenceIndex===1 ? 'bold' : ''}"
              style="cursor:pointer;"
              @click="onModelSentenceListPage(2)"
            >&nbsp;第2页&nbsp;</label>
            <label
              v-if="ModelSentenceList.length>=40"
              :style="{'font-weight':PageModelSentenceIndex===2 ? 'bold' : ''}"
              style="cursor:pointer;"
              @click="onModelSentenceListPage(3)"
            >&nbsp;第3页&nbsp;</label>
            <label
              v-if="ModelSentenceList.length>=60"
              :style="{'font-weight':PageModelSentenceIndex===3 ? 'bold' : ''}"
              style="cursor:pointer;"
              @click="onModelSentenceListPage(4)"
            >&nbsp;第4页&nbsp;</label>
            <label
              v-if="ModelSentenceList.length>=80"
              :style="{'font-weight':PageModelSentenceIndex===4 ? 'bold' : ''}"
              style="cursor:pointer;"
              @click="onModelSentenceListPage(5)"
            >&nbsp;第5页&nbsp;</label>
          </div>
        </div>
        <!-- 情景视频 -->
        <div v-if="isModelSentence == 3" style="width: 100%;margin-top: 5px;height: 100%;" class="row">
          <div v-if="scenedim.length>0" style="width: 200px;margin-right: 10px;padding-bottom: 10px;height:100%;" class="column">
            <el-scrollbar style="height:100%;">
              <div class="row" style="flex-wrap: wrap;">
                <div
                  v-for="(item,i) in scenedim"
                  :key="item.md5"
                  class="column"
                  style="margin: 5px;border-radius: 30px;font-weight: bold;color: white;border: solid 1px #e8e8e8;"
                  :style="{'background':(item.grouping==='10003'?'#000000': backgroundColor[i%4])}"
                  @click="onDim(item)"
                >
                  <!-- <el-image :src="item.cover" fit="cover" class="item-img" lazy style="height: 100px;border-radius: 6px 6px 0px 0px;" /> -->
                  <label style="font-size: 12px;padding: 10px;">{{ item.name }}</label>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div v-if="scenedim.length>0" class="video column" style="width: 100%;height: 100%;position: relative;background: black;">
            <video
              id="sceneVideo"
              ref="sceneVideo"
              oncontextmenu="return false;"
              style="outline: none;width: 100%;height: 100%;border-radius: 6px;"
              :src="sceneVideoUrl"
              controlslist="nodownload"
              controls
              @click.left="onsSceneVideoClickLeft"
              @timeupdate="onTimeupdate"
            ></video>
            <!-- 字幕 -->
            <div class="column" style="position: absolute;bottom: 30px;color: white;width: 100%;display: flex;justify-content: center;align-items: center;">
              <div v-if="subtitle && subtitle.english" style="background: #000000c2;padding: 5px 10px;border-radius: 8px;font-size: 16px;font-weight: bold;"> <label>{{ subtitle.english }}</label></div>
              <div v-if="subtitle && subtitle.chinese" style="background: #000000c2;padding: 5px 10px;border-radius: 8px;font-size: 14px;margin-top: 5px;"> <label>{{ subtitle.chinese }}</label></div>
            </div>
          </div>
          <div v-else style="text-align: center;width: 100%;">无相关情景视频</div>
        </div>
        <!-- Ai情景视频 -->
        <div v-if="isModelSentence == 4" style="width: 100%;margin-top: 5px;height: 100%;display: flex;justify-content: center;align-items: center;" class="row">
          <div v-if="isLogin" style="text-align: center;width: 100%;">Ai检索中</div>
          <div v-if="sceneVideoList.length>0 && !isLogin" style="background: black;width: 100%;display: flex;justify-content: center;align-items: center;">
            <div style="width: 80%;height: 80%; ">
              <video
                id="sceneVideo"
                ref="sceneVideo"
                oncontextmenu="return false;"
                autoplay
                style="outline: none;width: 100%;border-radius: 6px;"
                :style="{'height':(youDaoSize.height-400)+'px'}"
                :src="sceneVideoUrl"
                @click.left="onsSceneVideoClickLeft"
                @timeupdate="onTimeupdate"
                @play="onSceneVideoPlay"
              ></video>
              <div class="column" style="position: absolute;bottom: 10px;width: 80%;text-align: center;">
                <div style="display: flex;justify-content: center;align-items: center;">
                  <span style="color: white;border-radius: 20px;padding: 0px 20px;font-size: 12px;" :style="{'background':(sceneVideoList[sceneVideoIndex].type===-1?'#c800e3':'#e36000')}">{{ sceneVideoList[sceneVideoIndex].type===-1?'过去':'未来' }}：{{ sceneVideoList[sceneVideoIndex].name }}</span>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;margin-top: 10px;">
                  <span style="background: black;color: white;font-size: 26px;padding: 0px 20px;border-radius: 6px;">{{ sceneVideoList[sceneVideoIndex].english }}</span>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;">
                  <span style="background: black;color: white;font-size: 16px;margin-top: 10px;padding: 0px 20px;border-radius: 6px;">{{ sceneVideoList[sceneVideoIndex].chinese }}</span>
                </div>
                <div class="row" style="text-align: center;margin-top: 10px;">
                  <div
                    v-for="(item,i) in sceneVideoList"
                    :key="i"
                    style="height:2px;width:25%;display: flex;justify-content: center;align-items: center;margin-right: 2px;margin-left:2px;"
                    :style="{'background':(i===sceneVideoIndex?'#c61200':(sceneVideoList[i].type===-1?'#c800e3':'#e36000')),'width':(100/sceneVideoList.length)+'%' }"
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
  </el-container>
</template>
<script>
import Vue from 'vue'
import 'video.js/dist/video-js.css'
import videojs from 'video.js'
// 引入语言包
import zhCN from 'video.js/dist/lang/zh-CN.json'
import { decimerAlgorithm, secondToTimeStr, jsonDeepClone } from '@/utils'
import {
  getVideo,
  getVideoList,
  videoSectional,
  addPlayProcess,
  sceneVideo,
  addWord,
  getAvName,
  searchMeiYin
} from '@/apis/video'
import {
  getSubtitle,
  getSubtitleAv,
  noteGood,
  customSubtitle,
  getSubtitleHollow,
  subtitleHollow,
  modelSentence,
  isNameHollow,
  wordPastFuture
} from '@/apis/subtitle'
import { getNoteList, addNode } from '@/apis/note'
import { upMinLoading, addError, sysKey, kls, fygTranslate } from '@/apis/sys'
import { isAvCollect, avCollect } from '@/apis/user'
import SparkMD5 from 'spark-md5'
import VueClipboard from 'vue-clipboard2'
import vueTouch from 'kim-vue-touch'
import { search, speechSynthesisToken } from '@/apis/ai'
import { isCollect, addHollow, hollowList, deHollow } from '@/apis/word-library'

videojs.addLanguage('zh-CN', zhCN)
Vue.use(VueClipboard)
Vue.use(vueTouch)

export default {
  name: 'Player',
  components: { },
  data() {
    return {
      jurisdiction: {},
      service: Vue.$conf.service[Vue.$conf.environment],
      uid: Vue.$conf.userInfo.id,
      userInfo: {}, // 用户信息
      asideWidth: 300,
      isControl: true,

      backgroundColor: ['#f87622', '#30b405', '#d74104', '#0496d7'], // 情景视频相关视频背景色

      allHollowList: [], // 全局挖空列表

      gid: '', // 分组ID
      vid: '', // 视频ID
      dir: '', // 上级目录
      locality: null, // 本地视频

      rateMax: 100,
      primaryColor: 'white',
      // 自定义控制面板
      activeName: 'list',
      isVideoLoading: false,
      videoVideoList: [], // 网络视频列表
      noteList: [], // 笔记列表
      videoMd5: '', // 当前视频文件的MD5值
      videoId: '', // 视频代码
      videoIsNetwork: false, // 当前视频文件是否是网络
      hideSubtitle: false, // 隐藏字幕

      audio: {}, // 音频播放
      percentage: 0, // 播放进度比分比
      percentageRange: false, // 是否显示播放进度范围
      isLoopStart: false, // 自定义播放范围开始状态
      isLoopEnd: false, // 自定义播放范围结束状态
      playOrPauseTitle: '播放', // 播放/暂停
      volume: 100, // 声音
      duration: 0, // 视频时长
      isLoading: true, // 正在加载中
      isPlay: false, // 是否播放
      currentTime: 0, // 当前播放时间，秒数
      currentTimeMillisecond: 0, // 当前播放时间，毫秒
      player: null, // 播放器
      sceneVideo: null, // 情景视频、讲解视频
      videoPath: '', // 视频路径
      errorMsg: undefined, // 错误消息
      playbackRate: 1, // 播放速率
      isStartPlay: false, // 是否开始播放
      selectionValue: '', // 选择的内容
      isLoadVideo: false, // 是否已加载视频
      isShowAssociation: false, // 是否显示字幕联想视频
      isShowNote: false, // 是否显示笔记
      noteWidth: '200px', // 联系笔记宽度

      isLoop: false, // 是否循环
      loopIndex: 0, // 循环索引
      isCustomLoop: false, // 自定义循环
      customStartTime: 0, // 自定义循环开始时间
      customEndTime: 0, // 自定义循环结束时间
      loopFill: { fill: 'white' }, // 循环播放样式 000000
      loopCount: 0, // 循环次数

      isSimplePause: true, // 单句暂停
      simplePauseIndex: -1, // 单句暂停索引

      isBlur: false, // 视频毛玻璃效果
      vagueFill: { fill: 'white' }, // 模糊视频样式

      isDubleSpeed: false, // 是否启用激发
      doubleSeedFill: { fill: 'white' }, // 激发视频效果

      subtitleList: [], // 字幕列表
      isShowChinessSubtitle: false, // 是否显示中文字幕
      isShowSubtitle: true, // 是否显示字幕
      currentSubtitle: null, // 当前英文字幕
      currentSubtitleHollow: null, // 当前挖空字幕
      sceneWord: null, // 当前情景池
      currentSubtitleZh: null, // 当前中文字幕
      englishText: null, // 当前英文字幕（不含样式）数组
      englishTextStr: '', // 当前英文字幕（不含样式）字符串
      sceneWordList: [], // 情景视频
      isEnglishText: false, // 是否显示英文字幕（不含样式）
      currentSubtitleIndex: -1, // 当前字幕索引
      currentSubtitleSid: '', // 当前字幕的sid
      currentSubtitleStartTime: 0, // 字幕开始时间
      currentSubtitleEndTime: 0, // 字幕结束时间

      // 有道词典翻译部分
      dialogDictionaryVisible: false, // 是否显示词典弹出框
      hiddenContainerHeight: '180px', // 隐藏内容高度
      youDaoHtml: '', // 有道翻译Html
      youdaoTitel: '', // 有道翻译标题

      // 联想视频播放部分
      dialogAssociationVisible: false, // 是否显示联想弹出框
      associationPlayer: null, // 联想播放器
      associationNotes: [], // 联想笔记
      avList: [], // 联想视频集合
      isAssociationDialog: false, // 是否已打开联想视频

      // 提交笔记部分
      dialogAddNoteVisible: false, // 弹框
      addNoteHtmlIng: false, // 生成图片中
      addNoteForm: {}, // 添加笔记表单对象
      addNoteIng: false, // 提交中

      // 提交问题反馈
      dialogfeedbackVisible: false, // 弹框
      feedbackHtmlIng: false, // 生成图片中
      feedbackForm: {}, // 表单
      addFeedbackIng: false, // 提交中
      isNoteDialog: false, // 是否已打开笔记弹窗

      // 播放器配置
      playerOptions: {
        muted: false,
        width: 800,
        height: 300,
        fluid: false,
        autoplay: true,
        language: 'zh-CN',
        controls: false,
        preload: 'auto',
        playbackRates: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0],
        notSupportedMessage: '此视频暂时无法播放，请稍后重试'
      },
      isScreen: false, // 是否全屏
      isContraction: true, // 收缩左侧栏
      isScreenFill: 'white', // 按钮颜色000000
      keydown: '', // 快捷键
      sysKeydownList: [], // 系统快捷键
      isSelectedTake: false, // 字幕按住拖动选择
      takeButtonsType: 1, // 滑词鼠标按键类型（1:左键 2:右键）
      isSelectedInedx: -1, // 字幕划词开始索引

      enFontSize: 20, // 英文字体大小
      zhFontSize: 18, // 中文字体大小

      // 新前后多情景
      sceneVideoWord: '', // 当前情景视频搜索值
      sceneVideoList: [], // 情景视频列表
      isSceneVideoTooltip: true, // 气泡显示
      sceneVideoOpen: false, // 情景视频播发窗口
      sceneVideoUrl: '', // 情景视频播放地址
      sceneVideoSubtitle: [], // 情景视频字幕
      sceneVideoPayState: false, // 情景视频播放状态
      sceneVideoIsPlay: true, // 情景视频播放状态
      sceneVideoIndex: -1, // 新前后多情景视频索引
      s1: -1, // 分组排序
      s2: -1, // 视频排序
      isLogin: false, // 情景视频检索中

      errorCurrentTime: 0, // 异常重播断点秒

      continuePlay: true, // 断点续播弹窗
      continuePlayTime: 0, // 断点续播时间
      continuePlayCountdown: 5, // 断点续播倒计时
      continuePlayInterval: null, // 倒计时
      isCollect: false, // 查词是否已收藏

      isOnSceneMοuseοver: false, // 是否是情景视频搜索按钮进入

      hollowType: 1, // 挖空选项
      hollowList: [], // 挖空字幕集合
      isOpenHollow: false, // 是否打开挖空窗口
      isHollowDown: false, // 挖空字幕鼠标是否按下
      hollowDownIndex: 0, // 挖空字幕鼠标按下索引
      hollowIndex: -1, // 正在播放的挖空字幕索引
      hollowPlay: {
        isPlay: false,
        startMillisecond: 0,
        endMillisecond: 0
      }, // 挖空播放数据
      msLogin: true, // 例句检索中
      isModelSentence: 1, // 滑词例句
      ModelSentenceList: [], // 例句总集合
      PageModelSentenceIndex: 0, // 例句分页索引
      PageModelSentenceList: [], // 例句分页集合
      ModelSentenceWordList: [], // 例句搜索记录
      isNameHollow: false, // 是否根据名称自动挖空

      isFileName: true, // 是否隐藏文件名
      playMode: '0', // 列表播放模式

      isAvCollect: false,

      hollowMarginTop: 0, // 挖空字幕距离
      translate: {
        basic: []
      }, // 有道翻译数据
      scenedim: [],
      subtitle: [],
      youdaoTextSize: 0, // 有道翻译字体增加大小
      youDaoSize: { // 有道翻译窗口大小
        width: 0,
        height: 0
      },
      htmlType: 0, // 翻译类型
      klsHtml: '', // 柯林斯翻译HTML
      klsLoading: false, // 柯林斯英英词典
      jqHtml: '', // 柯林斯翻译HTML
      jqLoading: false,

      meiYinVideo: null, // 美音视频Url

      aiExplainLogin: false,
      aiExplainText: '', // Ai释义
      options: [{
        value: 0,
        label: '默认翻译 Ai'
      }, {
        value: 2,
        label: '默认翻译 中文'
      }],
      simplePause: false, // 单句播放暂停
      simplePauseFill: { fill: 'white' } // 单句播放暂停
    }
  },
  watch: {
    // 播放列表加载完成
    videoVideoList: function() {
      if (this.locality) return
      this.$nextTick(function() {
        this.$refs.videoScrollbar.wrap.scrollTop = document.getElementById(
          'vid' + this.vid
        ).offsetTop
      })
    }
  },
  created() {
    var that = this
    var userInfo = JSON.parse(localStorage.getItem('user'))
    this.userInfo = userInfo
    this.uid = userInfo.id
    // 情景视频HTML（window事件转化到vue事件）
    window.onSceneVideoSearch = this.onSceneVideoSearch
    // 柯林斯发音（window事件转化到vue事件）
    window.onKeLinShiAudio = this.onKeLinShiAudio
    // Ai释义发音（window事件转化到vue事件）
    window.onPayAi = this.onPayAi
    // 情景视频HTML搜索按钮鼠标事件
    window.onSceneMοuseοver = function() {
      that.isOnSceneMοuseοver = true
    }
    window.onSceneMouseout = function() {
      that.isOnSceneMοuseοver = false
    }
    // 禁用鼠标右键
    window.oncontextmenu = function(e) {
      return false
      // 或者 e.preventDefault()
    }
    // 全局鼠标移动事件 控制情景视频播放按钮
    document.addEventListener('mousemove', e => {
      // console.log(`e  x(水平):${e.x}  y(纵向):${e.y}`)
      this.sceneBut(e)
    })
    // 禁用鼠标右键
    window.addEventListener('contextmenu', function(e) {
      e.preventDefault()
    })

    this.playMode = localStorage.getItem('playMode')

    this.jurisdiction = JSON.parse(localStorage.getItem('user')).jurisdiction
    that.youDaoSize.width = document.documentElement.clientWidth
    that.youDaoSize.height = document.documentElement.clientHeight
    console.log(localStorage.getItem('HtmlType'))
    if (localStorage.getItem('HtmlType')) { this.htmlType = parseInt(localStorage.getItem('HtmlType')) } else { this.htmlType = 0 }
    if (localStorage.getItem('simplePause') != null) {
      this.simplePause = localStorage.getItem('simplePause') === 'true'
      this.simplePauseFill.fill = !this.simplePause
        ? this.isScreen
          ? 'white'
          : 'white'
        : '#C61200'
    }
  },
  // 退出页面
  beforeRouteLeave(to, form, next) {
    document.onkeydown = {}
    next()
  },
  mounted() {
    var that = this
    Vue.$openLocalFile(false)
    this.gid = this.$route.query.g
    this.vid = this.$route.query.v
    this.dir = this.$route.query.dir
    this.locality = this.$route.query.locality
    var isLocalVideoSubtitle = this.$route.query.isLocalVideoSubtitle
    this.audio = new Audio()
    if (this.vid) this.handleLoadVideo(this.vid)
    if (this.gid) this.getVideoList()
    // 本地视频
    if (this.locality && !isLocalVideoSubtitle) {
      var localityvideos = JSON.parse(localStorage.getItem('localityvideo'))
      this.videoVideoList = localityvideos
      this.handleLoadVideo({
        url: localityvideos[0].src,
        md5: localityvideos[0].md5,
        subtitle: null
      })
    } else if (isLocalVideoSubtitle) { // 本地视频、字幕
      this.handleLoadVideo({
        url: this.locality.src,
        md5: '',
        subtitle: this.locality.subtitle
      })
    }
    Vue.$handleLoadVideo = function(obj) {
      that.handleLoadVideo(obj)
    }
    Vue.$onkeydown = function() {
      that.onkeydown()
    }
    // 窗口变化
    window.onresize = function() {
      that.youDaoSize.width = document.documentElement.clientWidth
      that.youDaoSize.height = document.documentElement.clientHeight
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled
      if (isFull === undefined) {
        that.isScreen = false
        Vue.$screen(false)
        that.exitFullscreen()
      }
      var isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      if (document.documentElement.clientWidth <= 950 && !isMobile) {
        that.isControl = false
      } else {
        that.isControl = true
      }
    }
    // 播放状态下每5秒记录播放进程
    setInterval(function() {
      if (that.isPlay) {
        addPlayProcess({
          md5: that.videoMd5,
          lastTime: that.currentTimeMillisecond
        }).then(res => {
          // Vue.$day()
          Vue.$setPage()
        })
      }
    }, 1000 * 5)
    // 快捷键
    that.onkeydown()
    sysKey({}).then(res => {
      that.sysKeydownList = res.data
    })
    this.$refs.video.addEventListener('mousewheel', e => {
      this.onMouseWheel(e)
    })
    // iframe传递快捷键
    window.addEventListener('message', function(event) {
      that.sysKey(event.data, that)
    })
    // 字幕字体设置
    if (localStorage.getItem('zhSize') != null) {
      that.zhFontSize = localStorage.getItem('zhSize')
    }
    if (localStorage.getItem('enSize') != null) {
      that.enFontSize = localStorage.getItem('enSize')
    }
    if (localStorage.getItem('showZh') != null) {
      that.isShowChinessSubtitle = localStorage.getItem('showZh') === 'true'
    }
    if (localStorage.getItem('youdaoTextSize') != null) {
      that.youdaoTextSize = Number(localStorage.getItem('youdaoTextSize'))
    }
    // 字幕大小设置
    Vue.$SubtitleSet = function() {
      if (localStorage.getItem('zhSize') != null) {
        that.zhFontSize = localStorage.getItem('zhSize')
      }
      if (localStorage.getItem('enSize') != null) {
        that.enFontSize = localStorage.getItem('enSize')
      }
      that.$nextTick(function() {
        if (that.$refs.enSceneSubtitle) {
          that.hollowMarginTop = 0 - that.$refs.enSceneSubtitle.offsetHeight
        }
      })
    }
    Vue.$ShowZh = function() {
      that.isShowChinessSubtitle = localStorage.getItem('showZh') === 'true'
    }
    // 未开启中文显示控制权限默认显示中文
    if (!this.jurisdiction.functions['cc']) {
      this.isShowChinessSubtitle = true
    }
    // 3秒后自动隐藏视频
    setTimeout(() => {
      this.isFileName = false
    }, 3000)
    // 获取全局挖空列表
    hollowList().then(res => {
      this.allHollowList = res.data
    })
    Vue.$playeVideo = function(vid) {
      that.vid = vid
      that.handleLoadVideo(vid)
    }
  },
  methods: {
    // tabs 点击事件
    handleTabClick(name) {
      this.activeName = name
    },

    // 获取视频列表
    getVideoList() {
      this.isVideoLoading = true
      getVideoList({
        gid: this.gid,
        tag: this.gid === '8' ? this.$route.query.t : '',
        page: {
          index: 1,
          rows: 10000
        }
      })
        .then(res => {
          this.videoVideoList = res.data
        })
        .finally(_ => {
          this.isVideoLoading = false
        })
    },

    // 打开本地视频
    onOepnLocalFile() {
      this.$refs.localFileInput.dispatchEvent(new MouseEvent('click'))
    },

    // 处理文件改变
    handleFileChange() {
      const that = this
      this.onTogglePlay()
      if (this.$refs.localFileInput.files.length === 0) return
      var file = this.$refs.localFileInput.files[0]
      // 生成临时地址
      const src = window.URL
        ? window.URL.createObjectURL(file)
        : window.webkitURL.createObjectURL(file)

      const spark = new SparkMD5.ArrayBuffer()
      const reader = new FileReader()
      const size = file.size
      const offset = 2 * 1024 * 1024
      // hash抽样: 第一个区块2M，中间区块取前中后各2个字节，最后区块数据全要
      const chunks = [file.slice(0, offset)]
      let cur = offset
      while (cur < size) {
        if (cur + offset >= size) {
          chunks.push(file.slice(cur, cur + offset))
        } else {
          const mid = cur + offset / 2
          const end = cur + offset
          chunks.push(file.slice(cur, cur + 2))
          chunks.push(file.slice(mid, mid + 2))
          chunks.push(file.slice(end - 2, end))
        }
        cur += offset
      }
      reader.readAsArrayBuffer(new Blob(chunks))
      reader.onload = function() {
        spark.append(this.result)
        var md5 = spark.end()
        that.$refs.localFileInput.value = '' // 清空文件
        // 将计算后的结果打开视频
        that.handleLoadVideo({
          url: src,
          md5: md5
        })
      }
    },

    // 加载视频信息
    async handleLoadVideo(obj, index) {
      if (this.locality && index) {
        obj = {
          url: this.videoVideoList[index].src,
          md5: this.videoVideoList[index].md5,
          subtitle: null
        }
      }
      // 判断是否为对象
      const paramIsObject = typeof obj === 'object'

      //  判断传入的数据是否为对象，如果不是对象则需要充接口中获取视频信息，
      let video = obj
      if (!paramIsObject) {
        // 从接口中获取视频对象
        const res = await getVideo({ id: obj })
        this.s1 = res.data.s1
        this.s2 = res.data.s2

        // 续播弹窗
        if (res.data.lastTime > 1000) {
          if (this.continuePlayInterval) {
            clearInterval(this.continuePlayInterval)
          }
          this.continuePlayCountdown = 5
          this.continuePlay = true
          this.continuePlayTime = res.data.lastTime
          this.continuePlayInterval = setInterval(() => {
            this.continuePlayCountdown -= 1
            if (this.continuePlayCountdown === 0) {
              this.continuePlay = false
              clearInterval(this.continuePlayInterval)
              this.continuePlayCountdown = 5
            }
          }, 1000)
        } else this.continuePlay = false
        video = res.data
        this.videoIsNetwork = true // 是网络文件
        this.videoId = obj
        // 检查视频是否收藏
        isAvCollect({ aid: this.videoId }).then(res => {
          this.isAvCollect = res.data
        })
      } else {
        this.videoIsNetwork = false // 是本地文件
        this.videoId = ''
        this.continuePlay = false
      }

      // md5赋值
      this.videoMd5 = video.md5

      this.isLoadVideo = true // 是否已加载视频

      // 初始化设置
      this.percentage = 0 // 播放进度比分比
      this.playOrPauseTitle = '播放' // 播放/暂停
      this.volume = 50 // 声音
      this.duration = 0 // 视频时长
      this.isPlay = false // 是否播放
      this.currentTime = 0 // 当前播放进度，秒数
      // this.playbackRate = 1 // 播放速率
      this.isStartPlay = false // 是否开始播放
      this.selectionValue = '' // 选择的内容
      this.isShowAssociation = false // 是否显示字幕联想视频
      this.isShowNote = false // 是否显示笔记
      this.isLoop = false // 是否循环
      this.loopFill = { fill: 'white' } // 循环播放样式
      // this.isBlur = false // 视频毛玻璃效果
      // this.vagueFill = { fill: 'white' } // 模糊视频样式
      this.isDubleSpeed = false // 是否启用激发
      this.doubleSeedFill = { fill: 'white' } // 激发视频效果
      this.subtitleList = [] // 字幕列表
      this.isShowSubtitle = false // 是否显示字幕
      this.currentSubtitle = null // 当前英文字幕
      this.sceneWord = null // 当前情景词
      this.currentSubtitleZh = null // 当前中文字幕
      this.englishText = null // 当前英文字幕（不含样式）数组
      this.englishTextStr = '' // 当前英文字幕（不含样式）字符串
      this.sceneWordList = [] // 情景视频
      this.currentSubtitleSid = '' // 当前字幕编码
      this.currentSubtitleIndex = -1 // 当前字幕的索引
      this.currentSubtitleStartTime = 0 // 字幕开始时间
      this.currentSubtitleEndTime = 0 // 字幕结束时间
      // this.hideSubtitle = false // 隐藏字幕
      this.loopCount = 0 // 循环次数0

      // 处理视频的地址
      const videoPath = `${video.url}`
      this.videoPath = videoPath

      // 同步获取字幕
      if (video.md5) {
        // 云字幕
        const { data } = await getSubtitle({ md5: video.md5 })
        // 检查是否根据名称自动挖空
        isNameHollow({ md5: video.md5 }).then(res => {
          this.isNameHollow = res.data
        })
        this.subtitleList = data
        this.dismantleHollow()
      } else {
        // 学员自定义字幕
        const { data } = await customSubtitle({ subtitle: obj.subtitle })
        this.subtitleList = data
      }

      // 异步获取当前用户当前视频的笔记
      getNoteList({
        Md5: video.md5,
        Page: {
          Index: 1,
          Rows: 100
        }
      }).then(res => {
        this.noteList = res.data
      })

      // 如果播放器存在，则直接设置播放url即可
      if (this.player) {
        this.player.src({
          type: 'video/mp4',
          src: videoPath
        })
        this.simplePauseIndex = -1
        return
      }

      // 首次进行配置项加载
      this.playerOptions.sources = [
        {
          type: 'video/mp4',
          // videoPath
          src: videoPath
        }
      ]

      // 创建播放器实例
      const that = this
      this.player = videojs(
        this.$refs.videoPlayer,
        this.playerOptions,
        function onPlayerReady() {
          // 设置音量
          this.volume(that.volume)
          // 设置允许跨域
          this.setAttribute('crossOrigin', 'anonymous')

          // 设置速率
          console.log(`获取到当前播放器的速率：${this.playbackRate()}`)

          // 播放事件
          this.on('play', function() {
            that.isPlay = true
            that.isStartPlay = true
            that.playOrPauseTitle = '暂停'
            that.player.playbackRate(that.playbackRate)
          })

          // 暂停事件
          this.on('pause', function() {
            that.isPlay = false
            that.playOrPauseTitle = '播放'
          })

          // 媒体数据加载完成
          this.on('loadedmetadata', function() {
            console.log(`获取到当前视频的时长：${this.duration()}`)
            // 获取视频的总时长
            that.duration = Math.floor(this.duration())
            that.isLoading = false
          })

          // 时间更新事件
          this.on('timeupdate', function() {
            that.isSimplePause = localStorage.getItem('simplePause') === 'true'
            // 判断当前是否处于循环中
            const looping =
              that.isLoop || that.isDubleSpeed || that.isCustomLoop
            // 获取当前已播放的比例
            const c = this.currentTime() // 获取当前时间
            // 获取当前播放的字幕
            const currentMillisecondCeil = Math.ceil(c * 1000) // 处理成毫秒
            // 挖空播放(自动暂停)
            if (that.hollowPlay.isPlay) {
              if (currentMillisecondCeil >= that.hollowPlay.endMillisecond) {
                that.player.pause()
                that.hollowPlay.isPlay = false
                return
              }
            }
            // 赋值毫秒值
            that.currentTimeMillisecond = currentMillisecondCeil

            // 获取当前时间的字幕和字幕所在的索引
            const currentSubtitle = that.subtitleList.find((x, index) => {
              if (x.startMillisecond <= currentMillisecondCeil) {
                that.currentSubtitleIndex = index
                if (that.simplePauseIndex === -1) {
                  that.simplePauseIndex = index
                }
                return true
              }
              return false
            })
            // 循环播放（循环播放或激发需要需要循环）
            if (looping) {
              // 自定义AB循环
              let endRangeTime = null
              let startRangeTime = null
              if (
                that.isCustomLoop &&
                that.customEndTime > 0 &&
                that.customStartTime > 0
              ) {
                endRangeTime = that.customEndTime
                startRangeTime = that.customStartTime
                // 如果当前播放进度大于设定的自定义结束时间
                if (currentMillisecondCeil >= that.customEndTime) {
                  const currentTimeStart = decimerAlgorithm(
                    that.customStartTime,
                    1000,
                    '/'
                  )
                  this.currentTime(currentTimeStart)
                  that.loopCount += 1
                }
              } else {
                const {
                  startMillisecond: preStartMillisecond,
                  endMillisecond
                } = that.subtitleList[that.loopIndex]
                endRangeTime = endMillisecond
                startRangeTime = preStartMillisecond
                // 在当前时间大于当前字母语句的结束时间时，则设置为开始时间(优化不使用索引，使用时间轴算法)
                if (c > endRangeTime / 1000) {
                  const currentTimeStart = decimerAlgorithm(
                    preStartMillisecond,
                    1000,
                    '/'
                  )
                  this.currentTime(currentTimeStart)
                  that.loopCount += 1
                }
              }
              // 处理播放进度条和时间显示
              that.currentTime = Math.floor(c)
              const a = decimerAlgorithm(
                Math.floor(startRangeTime / 1000),
                that.duration,
                '/'
              )
              const b = decimerAlgorithm(a, that.rateMax, '*')

              // 字幕结束时间
              const f = decimerAlgorithm(
                Math.floor(endRangeTime / 1000),
                that.duration,
                '/'
              )
              const d = decimerAlgorithm(f, that.rateMax, '*')
              // 设置播放进度
              that.percentageRange = true
              that.percentage = [Number(b), Number(d)]
            } else {
              // 不循环时，设置循环次数为0
              if (that.loopCount !== 0) {
                that.loopCount = 0
              }
              // 处理播放进度条和时间显示
              that.currentTime = Math.floor(c)
              const a = decimerAlgorithm(c, that.duration, '/')
              const b = decimerAlgorithm(a, that.rateMax, '*')
              // 设置播放进度
              that.percentageRange = false
              //  自定义AB点循环选进度
              if (that.isLoopStart) {
                const s1 = decimerAlgorithm(
                  Math.floor(that.customStartTime / 1000),
                  that.duration,
                  '/'
                )
                const s2 = decimerAlgorithm(s1, that.rateMax, '*')
                that.percentageRange = true
                that.percentage = [Number(s2), Number(b)]
              } else that.percentage = Number(b)
            }
            // 判断是否处于激发模式
            if (that.isDubleSpeed) {
              if (that.loopCount > 0 && that.playbackRate !== 1.5) {
                // 循环索引
                const loopIndex = that.loopCount % 12
                const seed = decimerAlgorithm(0.1, loopIndex, '*')
                var ratio = 0.4
                if (localStorage.getItem('payRatio') != null) {
                  ratio = localStorage.getItem('payRatio')
                }
                // 倍率
                that.playbackRate = Number(decimerAlgorithm(ratio, seed, '+'))
                this.playbackRate(that.playbackRate)
              }
            }
            // 单句播放暂停
            if (that.isSimplePause && !looping && !that.isDubleSpeed && that.simplePauseIndex !== -1) {
              if (currentSubtitle !== undefined) {
                that.percentageRange = true
                // 字幕开始时间
                const a = decimerAlgorithm(
                  Math.floor(currentSubtitle.startMillisecond / 1000),
                  that.duration,
                  '/'
                )
                const b = decimerAlgorithm(a, that.rateMax, '*')
                // 字幕结束时间
                const f = decimerAlgorithm(
                  Math.floor(currentSubtitle.endMillisecond / 1000),
                  that.duration,
                  '/'
                )
                const d = decimerAlgorithm(f, that.rateMax, '*')
                that.percentage = [Number(b), Number(d)]
                if (that.currentTimeMillisecond >= currentSubtitle.endMillisecond || that.simplePauseIndex !== that.currentSubtitleIndex) {
                  // console.log(that.subtitleList)
                  // console.log(that.simplePauseIndex)
                  this.currentTime(that.subtitleList[that.simplePauseIndex].startMillisecond / 1000)
                  // console.log(that.subtitleList[that.simplePauseIndex].startMillisecond)
                  that.onTogglePlay()
                  that.simplePauseIndex = -1
                }
              }
            } else if (!that.isSimplePause && !looping && !that.isDubleSpeed) {
              that.percentageRange = false
            }
            // 当前字幕如果与当前时间字幕不一样
            if (currentSubtitle?.englishText !== that.currentSubtitle) {
              // 挖空播放定位挖空字幕
              if (that.isOpenHollow) {
                that.hollowIndex =
                that.subtitleList.length - that.currentSubtitleIndex - 1
                var el = that.$refs['hollowDiv' + that.hollowIndex][0]
                var s = el.offsetTop // 元素相对于页面顶部的距离
                var x = el.offsetHeight // 元素自身高度
                var t = that.$refs.hollowScrollbar.$el.firstElementChild.scrollTop // 页面在垂直方向上滚动的距离
                var y = that.$refs.hollowScrollbar.$el.scrollHeight // 窗口可视区域的高度
                var isHidden = s + x > t && s + x < t + y
                if (!isHidden) {
                  that.$refs['hollowDiv' + that.hollowIndex][0].scrollIntoView({
                    block: 'center'
                  })
                }
              }
              // 赋值字幕相关字段
              if (currentSubtitle) {
                const {
                  english,
                  englishText,
                  chinese,
                  sid,
                  noteNum,
                  associateVideoNum,
                  startMillisecond,
                  endMillisecond,
                  lexicon,
                  sceneWordList
                } = currentSubtitle
                // 记录字幕单词学习库
                if (that.englishTextStr !== englishText) {
                  addWord({
                    word: englishText,
                    type: 2,
                    subtitle: sid
                  })
                }
                that.sceneWord = lexicon
                that.currentSubtitle = english
                that.sceneWordList = sceneWordList
                that.currentSubtitleZh = chinese
                that.englishTextStr = englishText
                // 处理挖空
                that.thisHollowSubtitles()
                // 处理情景字幕
                that.sceneWordList.forEach((element, sindex) => {
                  if (element.type !== 0) {
                    var searchKey = element.searchKey.split('◌')
                    var reg = new RegExp(`\\b${element.word}\\b`, 'g')
                    var play = ''
                    // 按长度排序情景词
                    searchKey = searchKey
                      .map(i => ({ raw: i, len: i.length }))
                      .sort((p, n) => n.len - p.len)
                      .map(i => i.raw)
                    if (searchKey.length >= 2) {
                      searchKey.forEach((x, i) => {
                        x = x.trim()
                        // 只显示第一个(最长的一个情景词)
                        if (i === 0) {
                          play = `<div style="font-size: 10px;position: absolute;background: #B62B1A;border-radius: 4px;width: 26px;height: 30px;" onclick='onSceneVideoSearch("${sindex}","-1")'>
                        <svg
                          t="1641809192219"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="30363"
                          data-darkreader-inline-fill
                          width="16"
                          height="16"
                        >
                          <path
                            d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                            fill="white"
                          />
                        </svg>
                      </div>`
                        }
                      })
                    // play = `<div class="column" style="bottom: -30px;position: absolute;align-items: baseline;">${play}</div>`
                    } else {
                      play = `<div style="font-size: 10px;position: absolute;background: #B62B1A;padding: 3px 3px 0px 5px;border-radius: 4px;height: 25px;" class='scenebut1' onclick='onSceneVideoSearch("${sindex}","-1")'>
                        <svg
                          t="1641809192219"
                          class="icon"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="30363"
                          data-darkreader-inline-fill
                          width="16"
                          height="16"
                        >
                          <path
                            d="M780.8 475.733333L285.866667 168.533333c-27.733333-17.066667-64 4.266667-64 36.266667v614.4c0 32 36.266667 53.333333 64 36.266667l492.8-307.2c29.866667-14.933333 29.866667-57.6 2.133333-72.533334z"
                            fill="white"
                          />
                        </svg>
                      </div>`
                    }
                    // 情景视频播放按钮
                    var search = `<div style="justify-content: center;align-items: center;position: absolute;top: -23px;left:0px;z-index: 99;opacity: 0;" class='scenebut'  onmouseover='onSceneMοuseοver()' onmouseout='onSceneMouseout()'>
                    ${play}</div>`
                    // 处理情景视频词块
                    if (that.jurisdiction.functions['msib']) {
                      if (searchKey[0] !== that.isNameHollow.name) {
                        that.currentSubtitle = that.currentSubtitle.replace(
                          reg,
                          `<span style="border-radius: 3px; background: #B62B1A;position: relative;"  class='scene-paly'>${element.word}${search}</span>`
                        )
                      }
                    }
                  }
                })

                that.englishText = []
                if (englishText) {
                  englishText.split(/\b/).forEach((elem, index) => {
                    that.englishText.push({
                      content: elem,
                      isSelected: false,
                      left: '',
                      right: '',
                      top: '',
                      bottom: ''
                    })
                  })
                }
                that.isShowAssociation = associateVideoNum > 0
                that.noteWidth = !that.isShowAssociation ? '100%' : '200px'
                that.isShowNote = noteNum > 0
                that.currentSubtitleStartTime = startMillisecond
                that.currentSubtitleEndTime = endMillisecond
                that.currentSubtitleSid = sid
                // 是否显示字幕
                if (!that.isShowSubtitle) {
                  that.isShowSubtitle = true
                }
              } else {
                that.currentSubtitle = undefined
                that.currentSubtitleZh = undefined
                that.currentSubtitleStartTime = undefined
                that.currentSubtitleEndTime = undefined
                that.currentSubtitleIndex = -1
                that.englishText = undefined
                that.englishTextStr = ''
                that.isShowAssociation = false
                that.noteWidth = !that.isShowAssociation ? '100%' : '200px'
                that.isShowNote = false
                that.isShowSubtitle = false
              }

              that.$nextTick(function() {
                if (that.$refs.enSceneSubtitle) {
                  that.hollowMarginTop = 0 - that.$refs.enSceneSubtitle.offsetHeight
                }
              })
            }
          })

          // 视频错误
          this.on('error', function() {
            if (that.currentTime > 0) that.errorCurrentTime = that.currentTime
            // 错误显示关闭
            this.errorDisplay.close()
            const { code } = this.error()
            console.log(this)
            switch (code) {
              case 1:
                that.errorMsg = '您中止了媒体播放'
                break
              case 2:
                that.errorMsg = '网络错误导致视频下载中途失败。'
                break
              case 3:
                that.errorMsg =
                  '由于视频文件损坏或是该视频使用了你的浏览器不支持的功能，播放终止。'
                break
              case 4:
                that.errorMsg = '无法找到此视频兼容的源。'
                break
              case 5:
                that.errorMsg = '视频已加密，无法解密。'
                break
            }
            that.isLoading = true
          })

          // 视频播放结束
          this.on('ended', function() {
            switch (localStorage.getItem('playMode')) {
              case '1':
                that.onReload()
                break
              case '2':
                that.videoVideoList.filter((item, index) => {
                  if (item.vid === that.videoId) {
                    if (index < that.videoVideoList.length - 1) {
                      var vid = that.videoVideoList[++index].vid
                      that.handleLoadVideo(vid)
                      that.$refs.videoScrollbar.wrap.scrollTop = document.getElementById(
                        'vid' + vid
                      ).offsetTop
                    }
                  }
                })
                break
              case '3':
                that.videoVideoList.filter((item, index) => {
                  if (item.vid === that.videoId) {
                    var vid = ''
                    if (index < that.videoVideoList.length - 1) {
                      vid = that.videoVideoList[++index].vid
                      that.handleLoadVideo(vid)
                    } else {
                      vid = that.videoVideoList[0].vid
                      that.handleLoadVideo(vid)
                    }
                    that.$refs.videoScrollbar.wrap.scrollTop = document.getElementById(
                      'vid' + vid
                    ).offsetTop
                  }
                })
                break
            }
          })
        }
      )
    },

    // 有道词典关闭
    handleDictionaryClose() {
      this.dialogDictionaryVisible = false
      this.isModelSentence = 1

      if (localStorage.getItem('HtmlType')) { this.htmlType = parseInt(localStorage.getItem('HtmlType')) } else { this.htmlType = 0 }
      this.ModelSentenceList = []
      this.ModelSentenceWordList = []
      this.aiExplainText = ''
      window.getSelection().empty()
      this.englishText.forEach(function(el, index) {
        el.isSelected = false
      })
      // this.youDaoHtml = ''
      // this.englishText.forEach(function(el, index) {
      //   el.isSelected = false
      //   el.left = ''
      //   el.right = ''
      //   el.top = ''
      //   el.bottom = ''
      // })
    },

    // 显示联想视频弹出框
    handleShowAssociationDialog() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      this.dialogAssociationVisible = true
      this.isAssociationDialog = true
      // 暂停当前视频
      this.player.pause()
      this.handleAssociationOpen()
    },

    // 联想视频关闭
    handleAssociationClose() {
      this.dialogAssociationVisible = false
      this.isAssociationDialog = false
      this.associationNotes = []
      this.avList = []
      if (this.player) {
        // this.player.play()
      }
      if (this.associationPlayer) {
        // 暂停
        this.associationPlayer.pause()
        this.associationPlayer.currentTime(0)
      }
    },

    // 处理联想视频打开事件，获取接口初始化视频
    handleAssociationOpen() {
      // 获取当前字幕的联想广告
      getSubtitleAv({
        sid: this.currentSubtitleSid
      }).then(res => {
        const { notes, avList } = res.data
        this.associationNotes = notes
        this.avList = avList
        // // 设置播放器选项
        // const options = {
        //   muted: false,
        //   id: +new Date(),
        //   language: 'zh-CN',
        //   preload: 'auto',
        //   controls: true,
        //   playbackRates: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0],
        //   notSupportedMessage: '此视频暂时无法播放，请稍后重试',
        //   sources: [
        //     {
        //       type: 'video/mp4',
        //       src: `${avUrl}`
        //     }
        //   ]
        // }
        // // 初始化视频
        // this.associationPlayer = videojs(
        //   this.$refs.videoAssociationPlayer,
        //   options,
        //   function onPlayerReady() {
        //     console.log('联想视频加载完成')
        //   }
        // )
      })
    },

    // 显示添加笔记弹出框
    async handleShowAddNoteDialog() {
      if (!this.jurisdiction.functions['an']) return
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (!this.player) return
      document.onkeydown = {}
      // 暂停视频
      this.player.pause()
      this.addNoteHtmlIng = true
      this.isNoteDialog = true
      // 处理屏幕截图
      if (this.videoIsNetwork) {
        // 获取视频的截图
        const { data: dataurl } = await videoSectional({
          avid: this.videoId,
          millisecond: this.currentTimeMillisecond
        })

        this.addNoteForm.screen = dataurl
      } else {
        // 原始的canvas转换图片
        var video = this.player.el().querySelector('video')
        const canvas = document.createElement('canvas')
        // scale the canvas accordingly
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        // draw the video at that frame
        canvas
          .getContext('2d')
          .drawImage(video, 0, 0, canvas.width, canvas.height)
        // convert it to a usable data URL
        this.addNoteForm.screen = canvas.toDataURL('image/jpeg').slice(23)
      }

      this.$nextTick(() => {
        this.addNoteHtmlIng = false
        this.dialogAddNoteVisible = true
      })
    },

    //  关闭添加笔记弹出框
    handleAddNoteClose() {
      this.onkeydown()
      this.$refs.video.addEventListener('mousewheel', e => {
        this.onMouseWheel(e)
      })
      this.dialogAddNoteVisible = false
      this.isNoteDialog = false
      this.addNoteForm = {}
      if (!this.player) return
      // this.player.play()
    },

    // 提交笔记添加
    async onSubmitAddNote() {
      if (!this.videoMd5) {
        this.$notify.warn({
          title: '警告',
          message: '请选择需要播放的视频'
        })
        return
      }

      if (!this.currentSubtitleSid) {
        this.$notify.warn({
          title: '温馨提示',
          message: '未能获取当前字幕数据'
        })
        return
      }

      // 加载中...
      this.addNoteIng = true

      // 上传小文件到服务器上
      const result = await upMinLoading({
        ImgBase64: this.addNoteForm.screen,
        Suffix: 'jpg'
      })
      const screen = result.data

      // 调用添加笔记接口
      addNode({
        Md5: this.videoMd5,
        Sid: this.currentSubtitleSid,
        Screen: screen,
        English: this.currentSubtitle,
        Chinese: this.currentSubtitleZh,
        Content: this.addNoteForm.content
      })
        .then(_ => {
          this.$notify.success({
            title: '成功',
            message: '添加笔记成功'
          })
          this.dialogAddNoteVisible = false
          this.addNoteForm = {}
          getNoteList({
            Md5: this.videoMd5,
            Page: {
              Index: 1,
              Rows: 100
            }
          }).then(res => {
            this.noteList = res.data
          })
        })
        .finally(_ => {
          this.addNoteIng = false
        })
    },

    // 显示问题反馈弹框
    handleShowFeedbackDialog() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (!this.player) return
      document.onkeydown = {}
      // 暂停视频
      this.player.pause()
      this.addNoteHtmlIng = true

      this.$nextTick(() => {
        this.addNoteHtmlIng = false
        this.dialogfeedbackVisible = true
      })
    },

    //  关闭问题反馈弹出框
    handleFeedbackClose() {
      this.dialogfeedbackVisible = false
      this.feedbackForm = {}
      if (!this.player) return
      this.player.play()
      this.onkeydown()
    },

    // 提交问题反馈
    async onSubmitFeedback() {
      if (!this.videoMd5) {
        this.$notify.warn({
          title: '温馨提示',
          message: '请选择需要播放的视频'
        })
        return
      }

      if (!this.currentSubtitleSid) {
        this.$notify.warn({
          title: '温馨提示',
          message: '未能获取当前字幕数据'
        })
        return
      }

      // 加载中...
      this.addFeedbackIng = true

      // // 上传小文件到服务器上
      // const result = await upMinLoading({
      //   ImgBase64: this.addNoteForm.screen,
      //   Suffix: 'jpg'
      // })
      // const screen = result.data

      // 调用添加问题反馈
      addError({
        // Screen: screen,
        // English: this.currentSubtitle,
        // Chinese: this.currentSubtitleZh,
        Md5: this.videoMd5,
        Sid: this.currentSubtitleSid,
        Millisecond: this.currentTimeMillisecond,
        Type: this.feedbackForm.type,
        Content: this.feedbackForm.content
      })
        .then(_ => {
          this.$notify.success({
            title: '成功',
            message: '问题反馈成功'
          })
          this.dialogfeedbackVisible = false
          this.feedbackForm = {}
        })
        .finally(_ => {
          this.addFeedbackIng = false
        })
    },
    // 秒数转换成时分秒格式
    secondToTimeStr,
    // 播放切换事件
    onTogglePlay() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (!this.player) return
      if (!this.isPlay) {
        this.player.play()
        this.dialogAssociationVisible = false
        this.onMouseleaveSubtitle()
      } else {
        this.player.pause()
      }
    },
    // 重播
    onReload() {
      // 设置播放资源路径并设置播放时间
      this.player.src({
        type: 'video/mp4',
        src: this.videoPath
      })
      this.errorMsg = undefined
      this.isLoading = false
      this.player.currentTime(this.errorCurrentTime)
    },
    // 调整播放进度条事件
    handlePercentageChange(value) {
      if (!this.player) return
      let rate = 0
      if (Object.prototype.toString.call(value) === '[object Array]') {
        rate = value[0] / this.rateMax
      } else {
        rate = value / this.rateMax
      }
      const time = decimerAlgorithm(rate, this.duration, '*')
      console.log(
        `当前点击滑动条值：${value}，设置播放器播放时间为${time.toFixed(0)}`
      )
      // 通过value计算当前已播放时间
      this.player.currentTime(time)
    },
    // 声音改变事件
    onVoiceChange() {
      if (!this.player) return
      this.player.volume(parseFloat(this.volume / this.rateMax))
    },
    // 设置速率
    handleRateCommand(command) {
      if (!this.player) return
      this.playbackRate = Number(command)
      this.player.playbackRate(this.playbackRate)
    },
    // 进度格式化提示框
    handleProgressFormatTooltip(value) {
      if (!value) {
        return '00:00'
      }
      const rate = value / this.rateMax
      const time = Number(decimerAlgorithm(rate, this.duration, '*').toFixed(0))
      return `${secondToTimeStr(time)}`
    },
    // 声音滑块格式化提示框
    handleVolumeFormatTooltip(value) {
      if (value === 0) {
        return '静音'
      }

      return `音量：${value} %`
    },
    // 字幕鼠标放开事件
    handleMouseUp() {
      // if (!this.player) return
      // if (window.getSelection().toString().length > 0) {
      //   document.execCommand('Copy')
      //   this.selectionValue = window.getSelection().toString()
      //   // 视频暂停
      //   this.player.pause()
      //   this.dialogDictionaryVisible = true
      // }
    },
    // ******************功能区的事件**************
    // 视频模糊
    onVideoBlur() {
      if (!this.jurisdiction.functions['bf']) return
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      this.isBlur = !this.isBlur
      this.vagueFill.fill = !this.isBlur
        ? this.isScreen
          ? 'white'
          : 'white'
        : '#C61200'
      if (!this.isBlur) {
        this.hideSubtitle = false
        this.isSceneVideoTooltip = false
      } else {
        this.hideSubtitle = true
        this.isSceneVideoTooltip = true
      }
    },
    // 循环播放当前句
    onLoop() {
      if (!this.jurisdiction.functions['sc']) return
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (this.isDubleSpeed) this.onDoubleSpeed()
      if (
        this.currentSubtitleIndex <= -1 ||
        this.currentSubtitleIndex > this.subtitleList.length - 1
      ) {
        // 提示
        this.$message({
          showClose: true,
          message: '当前无字幕，无法循环播放',
          type: 'warning'
        })

        return
      }
      this.isLoop = !this.isLoop
      if (this.isLoop) {
        // 深拷贝一个索引对象
        this.loopIndex = jsonDeepClone(this.currentSubtitleIndex)
      }
      this.loopFill.fill = !this.isLoop
        ? this.isScreen
          ? 'white'
          : 'white'
        : '#C61200'
    },
    // 激发播放当前句
    onDoubleSpeed() {
      if (!this.jurisdiction.functions['kti']) return
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (this.isLoop) this.onLoop()
      if (!this.player) return
      if (
        this.currentSubtitleIndex <= -1 ||
        this.currentSubtitleIndex > this.subtitleList.length - 1
      ) {
        // 提示
        this.$message({
          showClose: true,
          message: '当前无字幕，无法激发播放',
          type: 'warning'
        })

        return
      }
      this.isDubleSpeed = !this.isDubleSpeed
      this.doubleSeedFill.fill = !this.isDubleSpeed
        ? this.isScreen
          ? 'white'
          : 'white'
        : '#C61200'
      // 当取消时，设置当前播放速度为正常速度
      if (!this.isDubleSpeed) {
        this.playbackRate = 1
        this.player.playbackRate(1)
      } else {
        this.loopCount = 0
        // 深拷贝一个索引对象
        this.loopIndex = jsonDeepClone(this.currentSubtitleIndex)
      }
    },
    // 上一句
    onLastSentence() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (!this.player) return
      if (this.isCustomLoop) return
      if (this.currentSubtitleIndex >= this.subtitleList.length - 1) {
        if (this.currentSubtitleIndex === this.subtitleList.length - 1) {
          this.loopIndex = jsonDeepClone(this.currentSubtitleIndex)
          const { startMillisecond } = this.subtitleList[
            this.currentSubtitleIndex
          ]
          const c = decimerAlgorithm(startMillisecond, 1000, '/')
          this.player.currentTime(c)
        }
        return
      }
      // 激发模式下，速度调整为初始值
      if (this.isDubleSpeed) {
        this.loopCount = 1
        this.playbackRate = 0.5
      }
      this.currentSubtitleIndex++
      this.simplePauseIndex = this.currentSubtitleIndex
      // 深拷贝一个索引对象
      this.loopIndex = jsonDeepClone(this.currentSubtitleIndex)

      const { startMillisecond } = this.subtitleList[this.currentSubtitleIndex]

      const c = decimerAlgorithm(startMillisecond, 1000, '/')
      this.player.currentTime(c)
      if (this.isSimplePause) {
        this.player.play()
      }
    },
    // 下一句
    onNextSentence() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      if (!this.player) return
      if (this.isCustomLoop) return
      if (this.currentSubtitleIndex === 0) return
      if (this.currentSubtitleIndex <= -1) {
        // // 提示
        // this.$message({
        //   showClose: true,
        //   message: '当前为最后一句，无法进行下一句播放',
        //   type: 'warning'
        // })
        // return
        this.currentSubtitleIndex = this.subtitleList.length
        // this.currentSubtitleIndex = this.subtitleList.length
      }
      // 激发模式下
      if (this.isDubleSpeed) {
        this.loopCount = 1
        this.playbackRate = 0.5
      }
      this.currentSubtitleIndex--
      this.simplePauseIndex = this.currentSubtitleIndex
      // 深拷贝一个索引对象
      this.loopIndex = jsonDeepClone(this.currentSubtitleIndex)
      const { startMillisecond } = this.subtitleList[this.currentSubtitleIndex]

      const c = decimerAlgorithm(startMillisecond, 1000, '/')
      this.player.currentTime(c)
      if (this.isSimplePause) {
        this.player.play()
      }
    },
    // 全屏事件
    onFullscreen() {
      if (!this.player) return
      this.isScreen = !this.isScreen
      Vue.$screen()
      if (this.isScreen) this.launchFullscreen(document.documentElement)
      else this.exitFullscreen()
    },
    // 全屏
    launchFullscreen(element) {
      this.isScreenFill = 'white'
      this.doubleSeedFill.fill = !this.isDubleSpeed ? 'white' : '#C61200'
      this.loopFill.fill = !this.isLoop ? 'white' : '#C61200'
      this.vagueFill.fill = !this.isBlur ? 'white' : '#C61200'
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen()
      } else {
        var docHtml = document.documentElement
        var docBody = document.body
        var videobox = document.getElementById('videobox')
        var cssText = 'width:100%;height:100%;overflow:hidden;'
        docHtml.style.cssText = cssText
        docBody.style.cssText = cssText
        videobox.style.cssText = cssText + ';' + 'margin:0px;padding:0px;'
        document.IsFullScreen = true
      }
    },
    // 退出全屏
    exitFullscreen() {
      this.isScreenFill = 'white' // '#000000'
      this.doubleSeedFill.fill = !this.isDubleSpeed ? 'white' : '#C61200'
      this.loopFill.fill = !this.isLoop ? 'white' : '#C61200'
      this.vagueFill.fill = !this.isBlur ? 'white' : '#C61200'
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled
      if (isFull === undefined) return
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else {
        var docHtml = document.documentElement
        var docBody = document.body
        var videobox = document.getElementById('videobox')
        docHtml.style.cssText = ''
        docBody.style.cssText = ''
        videobox.style.cssText = ''
        document.IsFullScreen = false
        isFull.call(document)
      }
    },
    // 快捷键
    onkeydown() {
      if (this.dialogDictionaryVisible) this.handleDictionaryClose()
      var that = this
      document.onkeydown = function(e) {
        that.sysKey(e.key.trim().toLowerCase(), that)
      }
      document.onkeyup = function(e) {}
      that.keydown = ''
    },
    // 实现快捷键
    sysKey(key, that) {
      if (that.sceneVideoOpen) {
        return
      }
      switch (key) {
        case '[':
        case '【':
          if (!that.jurisdiction.functions['abc']) return
          this.isLoopStart = true
          this.customStartTime = this.currentTimeMillisecond
          if (this.isCustomLoop) {
            this.isCustomLoop = false
            this.isLoop = false
            this.loopFill.fill = !this.isLoop
              ? this.isScreen
                ? 'white'
                : 'white'
              : '#C61200'
            this.customStartTime = 0
            this.customEndTime = 0
            this.isLoopEnd = false
            this.isLoopStart = false
          }
          break
        case ']':
        case '】':
          if (!that.jurisdiction.functions['abc']) return
          if (this.customStartTime <= 0) {
            this.$message({
              message: '请先设置开始循环A点',
              type: 'warning'
            })
            return
          }
          if (!this.isPlay) return
          this.customEndTime = this.currentTimeMillisecond
          if (this.customEndTime - this.customStartTime < 1000) {
            this.$message({
              message: '自定义AB循环间隔不能低于1秒',
              type: 'warning'
            })
            return
          } else {
            this.isLoopEnd = true
            this.isLoopStart = false
            this.isCustomLoop = true
            this.isLoop = true
            this.loopFill.fill = !this.isLoop
              ? this.isScreen
                ? 'white'
                : 'white'
              : '#C61200'
          }
          break
        case 'escape':
          // if (that.dialogDictionaryVisible) that.handleDictionaryClose()
          break
        case '+': // 加0.1倍
        case 'shift++':
        case '=':
          if (!that.jurisdiction.functions['mc']) return
          var rateAdd = Number(that.playbackRate + 0.1).toFixed(1)
          that.handleRateCommand(rateAdd)
          break
        case '<': // 后退2秒
        case 'shift+<':
        case ',':
        case '，':
          if (!that.jurisdiction.functions['tsfar']) return
          var mil = that.currentTimeMillisecond / 1000 - 2
          if (mil <= 0) mil = 0
          that.player.currentTime(mil)
          break
        case 'w': // 单句循环
        case 'arrowup':
          if (!that.jurisdiction.functions['sc']) return
          that.onLoop()
          break
        case '>': // 前进两秒
        case 'shift+>':
        case '。':
        case '.':
          if (!that.jurisdiction.functions['tsfar']) return
          that.player.currentTime(that.currentTimeMillisecond / 1000 + 2)
          break
        case 'b': // 模糊化
          if (!that.jurisdiction.functions['bf']) return
          that.onVideoBlur()
          break
        case 'h': // 隐藏字幕
          if (!that.jurisdiction.functions['hts']) return
          that.hideSubtitle = !that.hideSubtitle
          that.isSceneVideoTooltip = !that.hideSubtitle
          break
        case 's': // 一键激发
        case 'arrowdown':
          if (!that.jurisdiction.functions['kti']) return
          that.onDoubleSpeed()
          break
        case 'd': // 下一句  arrowleft（左）
        case 'arrowright':
          if (!that.jurisdiction.functions['jfns']) return
          that.onNextSentence()
          break
        case '0': // 正常倍速
          if (!that.jurisdiction.functions['mc']) return
          that.handleRateCommand(1)
          break
        case 'n': // 添加笔记
          if (!that.jurisdiction.functions['an']) return
          if (!that.isNoteDialog) that.handleShowAddNoteDialog()
          else that.handleAddNoteClose()
          break
        case 'space': // 播放/暂停
        case '':
          that.onTogglePlay()
          break
        case '-': // 减0.1倍
        case 'shift+—':
        case 'shift+_':
          if (!that.jurisdiction.functions['mc']) return
          var rateMinus = Number(that.playbackRate - 0.1).toFixed(1)
          that.handleRateCommand(rateMinus)
          break
        case 'a': // 上一句
        case 'arrowleft':
          if (!that.jurisdiction.functions['jfns']) return
          that.onLastSentence()
          break
        case 'm': // 打开联想视频
          if (that.isShowAssociation || that.isShowNote) {
            if (!that.isAssociationDialog) that.handleShowAssociationDialog()
            else that.handleAssociationClose()
          }
          break
        case 'v': // 语音合成整句vv
          if (!that.jurisdiction.functions['vp']) return
          this.player.pause()
          this.aliPayText(that.englishTextStr)
          break
        case 'c': // 语音合成选择的句
          if (!that.jurisdiction.functions['cp']) return
          if (this.dialogDictionaryVisible) {
            this.aliPayText(that.youdaoTitel)
          }
          break
        case 'enter':
          if (this.dialogDictionaryVisible) {
            that.selectionValue = that.youdaoTitel
          }
          break
        case 'k': // 上一个视频
          if (that.videoVideoList.length >= 2) {
            that.videoVideoList.filter((item, index) => {
              if (item.vid === that.videoId) {
                if (index > 0) {
                  var vid = that.videoVideoList[--index].vid
                  that.handleLoadVideo(vid)
                }
              }
            })
          }
          break
        case 'l': // 下一个视频
          if (that.videoVideoList.length >= 2) {
            that.videoVideoList.filter((item, index) => {
              if (item.vid === that.videoId) {
                if (index < that.videoVideoList.length - 1) {
                  var vid = that.videoVideoList[++index].vid
                  that.handleLoadVideo(vid)
                }
              }
            })
          }
          break
      }
    },
    // 鼠标左键
    onClickLeft() {
      this.onTogglePlay()
      this.dialogDictionaryVisible = false
    },
    // 鼠标中键
    onClickMiddle() {
      this.onFullscreen()
    },
    // 鼠标右键
    onClickRight() {
      this.sysKey('v', this)
    },
    // 鼠标滚轮事件
    onMouseWheel(e) {
      var that = this
      var direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') that.onLastSentence()
      else that.onNextSentence()
    },
    // 左边播放列表鼠标移入事件
    onLeftMouseEnter() {},
    // 左边播放列表鼠标移出事件
    onLeftMouseLeave() {},
    // 字幕移入事件
    onMouseoverSubtitle() {
      if (this.isOnSceneMοuseοver) return
      this.isEnglishText = true
      if (
        localStorage.getItem('slip') === null ||
        localStorage.getItem('slip') === 'true'
      ) {
        if (this.playOrPauseTitle === '暂停') this.onTogglePlay()
      }
    },
    // 字幕移出事件
    onMouseleaveSubtitle() {
      if (this.dialogAssociationVisible) return
      this.isEnglishText = false
      this.isSelectedInedx = -1
      this.isSelectedTake = false
      if (!this.dialogDictionaryVisible) {
        this.englishText?.forEach(function(el, index) {
          el.isSelected = false
        })
      }
      if (
        (localStorage.getItem('slip') === null ||
          localStorage.getItem('slip') === 'true') &&
        !this.dialogDictionaryVisible
      ) {
        if (!this.sceneVideoOpen) this.player.play()
      }
    },
    // 单词鼠标按下事件
    onMousedownTake(index, obj) {
      this.takeButtonsType = event.buttons
      if (!this.jurisdiction.functions['fw'] && this.takeButtonsType === 1) return
      if (!this.jurisdiction.functions['se'] && this.takeButtonsType === 2) return
      this.dialogDictionaryVisible = false
      this.player.pause()
      for (let i = 0; i < this.englishText.length; i++) {
        this.englishText[i].isSelected = false
      }
      this.isSelectedInedx = index
      this.isSelectedTake = true
      obj.isSelected = true
      this.sceneBut(event)
    },
    // 单词鼠标移入事件
    onMouseoverTake(index, obj) {
      if (!this.isSelectedTake) {
        return
      }
      // *********************如果挖空单词超过1个则返回 只能挖空一个词*********************
      var selectedEl = this.englishText.filter((item, index) => item.isSelected === true)
      if (this.takeButtonsType === 2 && selectedEl.length === 1) return
      // *********************
      // 滑词逻辑
      if (this.isSelectedInedx <= index) {
        // 右滑
        for (let i = 0; i < this.englishText.length; i++) {
          // 标记选择
          if (i >= this.isSelectedInedx && i <= index) {
            this.englishText[i].isSelected = true
          } else {
            // 取消选择
            this.englishText[i].isSelected = false
          }
        }
      } else {
        // 左滑
        for (let i = 0; i < this.englishText.length; i++) {
          if (i <= this.isSelectedInedx && i >= index) {
            this.englishText[i].isSelected = true
          } else {
            this.englishText[i].isSelected = false
          }
        }
      }
    },
    // 单词鼠标松开事件
    onMouseupTake(e) {
      this.isSelectedTake = false
      this.isModelSentence = 1
      this.ModelSentenceList = []
      // 处理单词
      var selectedEl = this.englishText.filter((item, index) => item.isSelected === true)
      if (selectedEl.length === 0 && this.isSelectedInedx >= 0) {
        selectedEl = [this.englishText[this.isSelectedInedx]]
      } else if (selectedEl.length === 0 && this.isSelectedInedx < 0) return
      var paragraph = Array.from(selectedEl, x => x.content).join('')
      // 删除特殊字符
      paragraph = paragraph.replace(/\,/g, ' ')
      paragraph = paragraph.replace(/\./g, ' ')
      paragraph = paragraph.replace(/\?/g, ' ')
      paragraph = paragraph.replace(/\!/g, ' ')
      this.selectionValue = paragraph
      if (this.takeButtonsType === 1 && this.jurisdiction.functions['fw']) this.onLoginYoudao()
      if (this.takeButtonsType === 2 && selectedEl.length === 1 && this.jurisdiction.functions['se']) this.onHollow()
    },
    // 加载有道翻译
    onLoginYoudao() {
      if (
        localStorage.getItem('isOpenYouDao') === 'true' ||
        localStorage.getItem('isOpenYouDao') === null
      ) {
        if (this.selectionValue.trim() !== '') {
          this.dialogDictionaryVisible = true
        }
      }
      this.youdaoTitel = this.selectionValue
      // this.audio.src = `http://dict.youdao.com/speech?audio=${this.selectionValue}`
      // this.audio.play()
      this.aliPayText(this.selectionValue)
      this.aiExplainLogin = true
      search({ word: this.youdaoTitel.trim() }).then(res => {
        this.aiExplainText = ''
        this.aiExplainTexts = res.data.text.split('\n')
        res.data.text.split('\n').forEach((item, index) => {
          if (item !== '') {
            var payAi = `<svg onclick="onPayAi(${index})"  data-v-236478fb="" t="1714106921932" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4348" width="14" height="14" class="icon"><path data-v-236478fb="" d="M148.00896 365.010944l0 0.41984c-1.527808-0.256-3.084288-0.421888-4.685824-0.421888L53.37088 365.008896c-15.525888 0-28.110848 12.58496-28.110848 28.110848l0 264.2432c0 15.521792 12.587008 28.110848 28.110848 28.110848l89.952256 0c1.599488 0 3.158016-0.16384 4.685824-0.421888l0 0.41984 327.95648 227.69664L475.96544 131.692544 148.00896 365.010944z" fill="#222222" p-id="4349"></path><path data-v-236478fb="" d="M654.938112 185.229312l0 33.755136c170.579968 4.95616 307.339264 144.78336 307.339264 316.563456 0 171.782144-136.759296 311.605248-307.339264 316.565504l0 33.75104c189.210624-4.9664 341.07392-159.905792 341.07392-350.318592S844.148736 190.19776 654.938112 185.229312z" fill="#222222" p-id="4350"></path><path data-v-236478fb="" d="M624.664576 308.789248l0 21.848064c110.41792 3.209216 198.940672 93.71648 198.940672 204.910592 0 111.192064-88.522752 201.701376-198.940672 204.910592l0 21.85216c122.476544-3.213312 220.7744-103.50592 220.7744-226.762752C845.438976 412.295168 747.139072 312.004608 624.664576 308.789248z" fill="#222222" p-id="4351"></path><path data-v-236478fb="" d="M576.223232 395.034624l0 13.53728c68.421632 1.990656 123.275264 58.073088 123.275264 126.976s-54.853632 124.987392-123.275264 126.976l0 13.539328c75.894784-1.994752 136.808448-64.141312 136.808448-140.515328S652.118016 397.02528 576.223232 395.034624z" fill="#222222" p-id="4352"></path></svg>`
            this.aiExplainText += item + payAi + '<br>'
          }
        })
        this.aiExplainLogin = false
      })
      this.translate = {}
      fygTranslate({ word: this.youdaoTitel.trim(), uid: this.uid, isApi: true }).then(res => {
        this.translate = res.data
      })
      isCollect({ word: this.selectionValue }).then(res => {
        this.isCollect = res.data
      })
      searchMeiYin({ key: this.selectionValue }).then(res => {
        this.meiYinVideo = res.data
      })
      // 复制操作
      this.$copyText(this.selectionValue)
    },
    // 全局挖空
    onHollow() {
      var isWord = this.allHollowList.filter((item, index) => {
        if (item.word?.toLowerCase() === this.selectionValue.trim().toLowerCase()) {
          this.allHollowList.splice(index, 1)
          return item
        }
      })
      if (isWord.length > 0) {
        deHollow({ hid: isWord[0].id }).then(res => {
          this.onMouseleaveSubtitle()
          this.thisHollowSubtitles()
        })
      } else {
        addHollow({ word: this.selectionValue.trim() }).then(res => {
          this.allHollowList.push({ word: this.selectionValue.trim() })
          this.onMouseleaveSubtitle()
          this.thisHollowSubtitles()
        })
      }
    },
    // 视频点击
    onTouchPay(e) {
      this.onTogglePlay()
    },
    // 字幕点击
    onTouch(des, e) {},
    // 有道查词 获取焦点
    onSelectWordFocus() {
      document.onkeydown = {}
    },
    // 有道查词 失去焦点
    onSelectWordBlur() {
      var that = this
      document.onkeydown = function(e) {
        that.sysKey(e.key.trim().toLowerCase(), that)
      }
      document.onkeyup = function(e) {}
      that.keydown = ''
    },
    // 查词
    onSelectWordEnter() {
      this.isModelSentence = 1
      this.selectionValue = this.youdaoTitel
      // this.audio.src = `http://dict.youdao.com/speech?audio=${this.youdaoTitel}`
      // this.audio.play()
      this.aliPayText(this.youdaoTitel)
      this.onLoginYoudao()
      if (this.htmlType === 1) {
        this.onKls()
      } else if (this.htmlType === 3) {
        this.onJq()
      }
    },
    // 收藏单词
    onCollect() {
      // var that = this
      this.selectionValue = this.youdaoTitel
      addWord({
        word: this.selectionValue,
        type: 1,
        en: this.englishTextStr,
        cn: this.currentSubtitleZh,
        subtitle: this.currentSubtitleSid
      }).then(res => {
        this.isCollect = true
        // that.$notify.success({
        //   message: '收藏成功'
        // })
      })
    },
    // 搜索情景视频（打开情景视频）
    onSceneVideoSearch(word, i) {
      var that = this
      // 按长度排序情景词
      var searchKey = that.sceneWordList[word].searchKey
        .split('◌')
        .map(i => ({ raw: i, len: i.length }))
        .sort((p, n) => n.len - p.len)
        .map(i => i.raw)
      if (i > 0) {
        word = searchKey[i]
      } else {
        word = searchKey[0]
      }
      // var searchKey = element.searchKey
      // console.log(searchKey)
      that.isSceneVideoTooltip = false
      that.sceneVideoOpen = true
      that.sceneVideoWord = word
      sceneVideo({
        word: word,
        notMd5: this.videoMd5
      }).then(res => {
        that.sceneVideoUrl = res.data[0].url
        that.$refs.sceneVideo.currentTime = res.data[0].skip
        that.$refs.sceneVideo.focus()
        that.player.pause()

        // 播放事件
        that.$refs.sceneVideo.addEventListener('play', function() {
          that.$refs.sceneVideo.controls = true
          that.sceneVideoIsPlay = true
        })

        // 暂停事件
        that.$refs.sceneVideo.addEventListener('pause', function() {
          that.$refs.sceneVideo.controls = false
          that.sceneVideoIsPlay = false
        })
        // this.$refs.sceneVideo.play()
      })
    },
    // 情景视频左键点击
    // onsSceneVideoClickLeft() {
    //   if (!this.sceneVideoIsPlay) this.$refs.sceneVideo.play()
    //   // else this.$refs.sceneVideo.pause()
    // },
    // 移出情景视频
    onSceneVideoLeave() {
      this.isSceneVideoTooltip = true
      this.sceneVideoList = []
      this.sceneVideoWord = ''
    },
    // 打开联想视频
    async onSceneVideoOpen(url) {
      this.sceneVideoOpen = true
      this.sceneVideoUrl = url
    },
    // 联想视频播放/暂停
    onScene() {
      if (!this.sceneVideoPayState) this.$refs.sceneVideo.play()
      else this.$refs.sceneVideo.pause()
      this.sceneVideoPayState = !this.sceneVideoPayState
    },
    // 笔记点赞
    onNoteGood(nid, no) {
      noteGood({
        nid
      }).then(res => {
        no.isGood = 1
      })
    },
    // 创建情景视频播放器
    async creaSceneVideo(url, skip) {
      if (this.scenePlayer) {
        this.scenePlayer.src({
          type: 'video/mp4',
          src: url
        })
        return
      }
      // 设置播放器选项
      const options = {
        muted: false,
        id: +new Date(),
        language: 'zh-CN',
        preload: 'auto',
        controls: true,
        notSupportedMessage: '此视频暂时无法播放，请稍后重试',
        sources: [
          {
            type: 'video/mp4',
            src: `${url}`
          }
        ]
      }
      // 初始化视频
      this.scenePlayer = videojs(
        this.$refs.scenePlayer,
        options,
        function onPlayerReady() {}
      )
    },
    // 笔记跳转视频播放时间
    onNote(startMillisecond) {
      const c = decimerAlgorithm(startMillisecond, 1000, '/')
      this.player.currentTime(c)
    },
    // 字幕显示切换
    onSubtitle() {
      this.sysKey('h', this)
    },
    // 断点续播
    onContinuePlay() {
      this.continuePlay = false
      const c = decimerAlgorithm(this.continuePlayTime, 1000, '/')
      this.player.currentTime(c)
    },
    // 拆解挖空字幕
    dismantleHollow() {
      var that = this
      that.hollowList = []
      // console.log(this.subtitleList)
      getSubtitleHollow({ md5: that.videoMd5 }).then(res => {
        // console.log(that.subtitleList)
        // 无挖空记录
        if (
          res.data == null ||
          JSON.parse(res.data.json).length !== that.subtitleList.length
        ) {
          that.subtitleList.forEach(function(subtitle, index) {
            if (subtitle.englishText == null) {
              subtitle.englishText = ''
            }
            var wordList = subtitle.englishText.split(' ')
            var row = []
            wordList.forEach(function(word, index) {
              row.push({
                word: word, // 单词
                isSelect: false, // 是否选择
                isDivision: false, // 连接线
                value: 0, // 控制二次滑词
                type: 0, // 单词或语块 区别中间的链接线是否显示
                isProminent: false // 已选择的单词临时显示
              })
            })
            that.hollowList.splice(0, 0, {
              startMillisecond: subtitle.startMillisecond,
              endMillisecond: subtitle.endMillisecond,
              text: subtitle.englishText,
              list: row,
              isShowPlay: false,
              value: 0,
              sid: subtitle.sid,
              englishText: subtitle.englishText,
              chinese: subtitle.chinese
            })
          })
        } else {
          that.hollowList = JSON.parse(res.data.json)
          // console.log(that.hollowList)
        }
      })
    },
    // 挖空字幕单词移入
    onHollowMouseover(row, index, item) {
      if (!this.isHollowDown) {
        // 非鼠标按下状态
        if (
          (this.hollowType === 1 &&
            this.hollowList[row].list[index].type === 1 &&
            this.hollowList[row].list[index].isSelect) ||
          (this.hollowType === 3 &&
            (this.hollowList[row].list[index].type === 1 ||
              this.hollowList[row].list[index].type === 0) &&
            !this.hollowList[row].list[index].isSelect)
        ) {
          this.hollowList[row].list[index].isProminent = true
        } else if (
          (this.hollowType === 1 &&
            this.hollowList[row].list[index].type === 2 &&
            this.hollowList[row].list[index].isSelect) ||
          (this.hollowList[row].list[index].type === 2 &&
            this.hollowType === 3 &&
            !this.hollowList[row].list[index].isSelect)
        ) {
          // 从左至右开始显示
          for (let i = index; i < this.hollowList[row].list.length; i++) {
            if (
              (this.hollowType === 1 &&
                this.hollowList[row].list[i].type === 2 &&
                this.hollowList[row].list[i].isSelect) ||
              (this.hollowType === 3 &&
                this.hollowList[row].list[i].type === 2 &&
                !this.hollowList[row].list[i].isSelect)
            ) {
              this.hollowList[row].list[i].isProminent = true
            } else {
              break
            }
          }
          // 从右至左开始显示
          for (var i = 0; i <= index; i++) {
            if (
              (this.hollowType === 1 &&
                this.hollowList[row].list[index - i].type === 2 &&
                this.hollowList[row].list[index - i].isSelect) ||
              (this.hollowType === 3 &&
                this.hollowList[row].list[index - i].type === 2 &&
                !this.hollowList[row].list[index - i].isSelect)
            ) {
              this.hollowList[row].list[index - i].isProminent = true
            } else {
              break
            }
          }
        }
        return
      }
      // 滑词逻辑
      this.hollowList[row].list[this.hollowDownIndex].type = 2 // 标记为滑词单词
      if (this.hollowDownIndex <= index) {
        // 右滑
        for (let i = 0; i < this.hollowList[row].list.length; i++) {
          // 标记选择
          if (i >= this.hollowDownIndex && i <= index) {
            this.hollowList[row].list[i].value = this.hollowList[row].value
            this.hollowList[row].list[i].type = 2
            if (this.hollowType === 1) {
              // 正常挖空
              this.hollowList[row].list[i].isSelect = true
              this.hollowList[row].list[i].isDivision = true
            } else {
              // 翻转挖空
              this.hollowList[row].list[i].isSelect = false
              this.hollowList[row].list[i].isDivision = false
            }
          } else {
            // 取消选择
            if (
              this.hollowList[row].list[i].value === this.hollowList[row].value
            ) {
              this.hollowList[row].list[i].type = 0
              if (this.hollowType === 1) {
                // 正常挖空
                this.hollowList[row].list[i].isSelect = false
                this.hollowList[row].list[i].isDivision = false
              } else {
                // 翻转挖空
                this.hollowList[row].list[i].isSelect = true
                this.hollowList[row].list[i].isDivision = true
              }
            }
          }
        }
      } else {
        // 左滑
        for (let i = 0; i < this.hollowList[row].list.length; i++) {
          if (i <= this.hollowDownIndex && i >= index) {
            this.hollowList[row].list[i].value = this.hollowList[row].value
            this.hollowList[row].list[i].type = 2
            if (this.hollowType === 1) {
              this.hollowList[row].list[i].isSelect = true
              this.hollowList[row].list[i].isDivision = true
            } else {
              this.hollowList[row].list[i].isSelect = false
              this.hollowList[row].list[i].isDivision = false
            }
          } else {
            if (
              this.hollowList[row].list[i].value === this.hollowList[row].value
            ) {
              this.hollowList[row].list[i].type = 0
              if (this.hollowType === 1) {
                this.hollowList[row].list[i].isSelect = false
                this.hollowList[row].list[i].isDivision = false
              } else {
                this.hollowList[row].list[i].isSelect = true
                this.hollowList[row].list[i].isDivision = true
              }
            }
          }
        }
      }
      this.thisHollowSubtitles()
    },
    // 挖空字幕单词移出
    onHollowMouseleave(row, index, item) {
      if (!this.isHollowDown) {
        // 非鼠标按下状态
        if (
          (this.hollowType === 1 &&
            this.hollowList[row].list[index].type === 1 &&
            this.hollowList[row].list[index].isSelect) ||
          (this.hollowType === 3 &&
            (this.hollowList[row].list[index].type === 1 ||
              this.hollowList[row].list[index].type === 0) &&
            !this.hollowList[row].list[index].isSelect)
        ) {
          this.hollowList[row].list[index].isProminent = false
        } else if (
          (this.hollowType === 1 &&
            this.hollowList[row].list[index].type === 2 &&
            this.hollowList[row].list[index].isSelect) ||
          (this.hollowList[row].list[index].type === 2 &&
            this.hollowType === 3 &&
            !this.hollowList[row].list[index].isSelect)
        ) {
          // 从左至右开始显示
          for (let i = index; i < this.hollowList[row].list.length; i++) {
            if (
              (this.hollowType === 1 &&
                this.hollowList[row].list[i].type === 2 &&
                this.hollowList[row].list[i].isSelect) ||
              (this.hollowType === 3 &&
                this.hollowList[row].list[i].type === 2 &&
                !this.hollowList[row].list[i].isSelect)
            ) {
              this.hollowList[row].list[i].isProminent = false
            } else {
              break
            }
          }
          // 从右至左开始显示
          for (var i = 0; i <= index; i++) {
            if (
              (this.hollowType === 1 &&
                this.hollowList[row].list[index - i].type === 2 &&
                this.hollowList[row].list[index - i].isSelect) ||
              (this.hollowType === 3 &&
                this.hollowList[row].list[index - i].type === 2 &&
                !this.hollowList[row].list[index - i].isSelect)
            ) {
              this.hollowList[row].list[index - i].isProminent = false
            } else {
              break
            }
          }
        }
        return
      }
      this.thisHollowSubtitles()
    },
    // 挖空字幕单词按下
    onHollowMousedown(row, index, item) {
      this.hollowDownIndex = index
      for (let i = 0; i < this.hollowList[row].list.length; i++) {
        if (i === index) {
          this.hollowList[row].list[i].isSelect = !this.hollowList[row].list[i]
            .isSelect
          this.hollowList[row].list[i].isDivision = !this.hollowList[row].list[
            i
          ].isDivision
          this.hollowList[row].list[i].type = 1 // 标记为按下单词
          this.hollowList[row].list[i].isProminent = false
          this.hollowList[row].value += 1
          this.hollowList[row].list[i].value = this.hollowList[row].value
        } else {
          this.hollowList[row].list[i].isProminent = false
        }
      }
      this.thisHollowSubtitles()
    },
    // 挖空播放按钮
    onHollowPlay(startMillisecond, endMillisecond) {
      this.hollowPlay.startMillisecond = startMillisecond
      this.hollowPlay.endMillisecond = endMillisecond
      this.hollowPlay.isPlay = true
      const c = decimerAlgorithm(startMillisecond, 1000, '/')
      this.player.currentTime(c)
      this.player.play()
    },
    // 记录字幕挖空数据
    subtitleHollow(row) {
      var that = this
      if (that.isHollowDown) {
        subtitleHollow({
          md5: that.videoMd5,
          json: JSON.stringify(that.hollowList)
        })
        // 计算新选择的挖空词或短语
        var rowData = that.hollowList[row]
        // console.log(rowData)
        var value = rowData.value
        var rowWord = rowData.list
        var words = rowWord.filter(
          (item, index) => item.isSelect === true && item.value === value
        )
        var word = Array.from(words, x => x.word).join(' ')
        if (word) {
          // console.log(word)
          addWord({
            word: word,
            type: 4,
            en: rowData.englishText,
            cn: rowData.chinese,
            subtitle: rowData.sid
          })
        }
      }
    },
    // 搜索字幕例句
    onModelSentence() {
      var that = this
      this.isModelSentence = 2
      this.msLogin = true
      // 例句关键词搜索记录
      if (
        that.ModelSentenceWordList.length === 0 ||
        that.ModelSentenceWordList[that.ModelSentenceWordList.length - 1] !==
          this.youdaoTitel.trim()
      ) {
        that.ModelSentenceWordList.push(this.youdaoTitel.trim())
      }
      var example = localStorage.getItem('example')
      var zhOpacity = 0
      var enOpacity = 0
      if (example) {
        switch (example) {
          case '1':
            zhOpacity = 1
            enOpacity = 1
            break
          case '2':
            zhOpacity = 0
            enOpacity = 1
            break
          case '3':
            zhOpacity = 1
            enOpacity = 0
            break
          case '4':
            zhOpacity = 0
            enOpacity = 0
            break
        }
      }
      // 查询条件/排序
      var level = localStorage.getItem('level')
      var sort = localStorage.getItem('sort')
      var where = '1=1'
      if (level) {
        level = JSON.parse(level)
        if (level.length < 5 && level.length !== 0) {
          level.forEach(x => {
            if (where === '1=1') {
              where = `${where} and (`
            } else {
              where = `${where} or`
            }
            switch (x) {
              case '初级':
                where = `${where} ((t1.Frequency0>0 or t1.Frequency1>0) and t1.Frequency2=0 and t1.Frequency3=0 and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '初中级':
                where = `${where} ((t1.Frequency0>0 or t1.Frequency1>0 ) and t1.Frequency2>0 and t1.Frequency3=0 and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '中级':
                where = `${where} ((t1.Frequency2>0 or t1.Frequency3>0) and t1.Frequency4=0 and t1.Frequency5=0)`
                break
              case '中高级':
                where = `${where} ((t1.Frequency2>0 or t1.Frequency3>0 ) and t1.Frequency4>0 and t1.Frequency5=0)`
                break
              case '高级':
                where = `${where} ((t1.Frequency4>0 or t1.Frequency5>0))`
                break
            }
          })
          where = `${where} )`
        } else {
          where = ''
        }
      }
      if (sort) {
        sort = JSON.parse(sort)
        var orderBy = ''
        if (sort.length > 0) {
          if (where === '') {
            where = '1=1'
          }
          sort.forEach(x => {
            switch (x) {
              case '学习时间':
                orderBy = `${orderBy} t5.LearningTime DESC,`
                break
              case '例句长度':
                orderBy = `${orderBy} if(ISNULL(t1.Length),10000,t1.Length),`
                // where = `${where} and t1.Length>0`
                break
              case '复杂程度':
                orderBy = `${orderBy} if(ISNULL(t1.MaxLevel),7,t1.MaxLevel),`
                // where = `${where} and t1.MinLevel>0`
                break
            }
          })
          orderBy = orderBy.substring(0, orderBy.lastIndexOf(','))
        }
      }
      // 查询例句
      modelSentence({
        word: this.youdaoTitel.trim(),
        orderBy: orderBy,
        where: where
      }).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index]
          element.englishText = element.english
          that.youdaoTitel = that.youdaoTitel.trim()
          var symbol = that.youdaoTitel.substring(that.youdaoTitel.length - 1)
          if (
            symbol === '.' ||
            symbol === ',' ||
            symbol === '?' ||
            symbol === '!' ||
            symbol === '！' ||
            symbol === '？'
          ) {
            that.youdaoTitel = that.youdaoTitel.substring(
              0,
              that.youdaoTitel.length - 1
            )
          }
          var reg = new RegExp(`\\b${that.youdaoTitel}\\b`, 'i', 'g')
          element.english = element.english.replace(
            reg,
            `<span style="color: #00a803;opacity: 0;" id="msword${index}">${that.youdaoTitel}</span>`
          )
          element.english = `<span style="opacity: ${enOpacity};" id="msEnglish${index}">${element.english}</span>`
          if (element.chinese === null || element.chinese === '') {
            element.chinese = ''
            element.tempHtml = `<span style="opacity: ${zhOpacity};" id="msChinese${index}">无中文字幕，可选择机译</span>`
          } else {
            element.chinese = `<span style="opacity: ${zhOpacity};" id="msChinese${index}">${element.chinese}</span>`
          }
          element.isMsLoading = false
        }
        this.ModelSentenceList = res.data
        this.PageModelSentenceIndex = 0
        if (this.ModelSentenceList.length > 0) {
          if (this.ModelSentenceList.length < 20) {
            this.PageModelSentenceList = this.ModelSentenceList.slice(
              0,
              this.ModelSentenceList.length
            )
          } else {
            this.PageModelSentenceList = this.ModelSentenceList.slice(0, 20)
          }
        } else {
          this.PageModelSentenceList = []
        }
        this.msLogin = false
      })
    },
    // 合成例句发音
    onMsPlay(type, obj) {
      // console.log(obj)
      var that = this
      if (type === 1) {
        // this.audio.src = `http://dict.youdao.com/speech?audio=${obj}`
        // this.audio.play()
        this.aliPayText(obj)
      } else if (type === 2) {
        obj.isMsLoading = true
        this.audio.src = obj.audio
        this.audio.currentTime = obj.startMillisecond / 1000
        var audioTimeupdate = function(event) {
          if (that.audio.currentTime >= obj.endMillisecond / 1000) {
            that.audio.pause()
            that.audio.removeEventListener('timeupdate', audioTimeupdate)
            that.audio.removeEventListener('canplay', canplay)
          }
        }
        var canplay = function() {
          obj.isMsLoading = false
        }
        this.audio.play()
        this.audio.addEventListener('timeupdate', audioTimeupdate)
        this.audio.addEventListener('canplay', canplay)
      }
    },
    // 例句隐藏
    osMSOpacity(index) {
      if (document.getElementById('msEnglish' + index).style.opacity !== '1') {
        document.getElementById('msEnglish' + index).style.opacity = 1
      } else if (
        document.getElementById('msword' + index).style.opacity !== '1'
      ) {
        document.getElementById('msword' + index).style.opacity = 1
      } else if (
        document.getElementById('msChinese' + index).style.opacity !== '1'
      ) {
        document.getElementById('msChinese' + index).style.opacity = 1
      } else {
        var example = localStorage.getItem('example')
        if (example && example === '1') {
          document.getElementById('msword' + index).style.opacity = 0
        } else if (example && example === '2') {
          document.getElementById('msChinese' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
        } else if (example && example === '3') {
          document.getElementById('msEnglish' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
        } else if (!example || example === '4') {
          document.getElementById('msEnglish' + index).style.opacity = 0
          document.getElementById('msword' + index).style.opacity = 0
          document.getElementById('msChinese' + index).style.opacity = 0
        }
      }
    },
    // 例句后退
    onMSBack() {
      this.youdaoTitel = this.ModelSentenceWordList[
        this.ModelSentenceWordList.length - 2
      ]
      this.ModelSentenceWordList.pop()
    },
    // 例句翻页
    onModelSentenceListPage(page) {
      this.PageModelSentenceIndex = page - 1
      switch (page) {
        case 1:
          this.PageModelSentenceList = this.ModelSentenceList.slice(0, 20)
          break
        case 2:
          this.PageModelSentenceList = this.ModelSentenceList.slice(20, 40)
          break
        case 3:
          this.PageModelSentenceList = this.ModelSentenceList.slice(40, 60)
          break
        case 4:
          this.PageModelSentenceList = this.ModelSentenceList.slice(60, 80)
          break
        case 5:
          this.PageModelSentenceList = this.ModelSentenceList.slice(80, 100)
          break
      }
    },
    // 当前挖空字幕处理
    thisHollowSubtitles() {
      var that = this
      var hollow = that.englishTextStr
      if (
        localStorage.getItem('isHollow') === 'false'
      ) {
        that.currentSubtitleHollow = hollow
        return
      }
      // 全局挖空
      if (!that.isNameHollow.auto) {
        if (!this.jurisdiction.functions['se']) {
          that.currentSubtitleHollow = hollow
          return
        }
        this.allHollowList.forEach((ele) => {
          //    `\\b${ele.word}\\b(?=\\s|<|\\?)`
          var reg = new RegExp(`(\\b${ele.word}\\b)(?![^<]*>|[^<>]*</)`, 'gi') // new RegExp("(" + originalSen + ")([^>]*<)","gi"); 中([^>]*<)作用只替换html 标签外的匹配originalSen的部分。
          hollow = hollow.replace(
            reg,
            `<span style="border-width: 0px 0px 2px 0px;border-color: #ffffff;border-style: solid;color: transparent;">${ele.word}</span>`
          )
        })
        that.currentSubtitleHollow = hollow
      } else {
        // 自动根据视频名称挖空
        var reg = new RegExp(`\\b${that.isNameHollow.name}\\b`, 'gi')
        that.currentSubtitleHollow = hollow.replace(
          reg,
          `<span style="border-width: 0px 0px 2px 0px;border-color: #ffffff;border-style: solid;color: transparent;">${that.isNameHollow.name}</span>`
        )
      }
    },
    // 返回主页
    onBack() {
      if (
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.webkitFullScreen ||
        document.msFullScreen
      ) {
        this.onFullscreen()
      }
      if (this.dir === 'PALYLOG') {
        this.$router.push({
          path: '/palylog'
        })
      } else if (this.dir === 'AVCOLLECT') {
        this.$router.push({
          path: '/avcollect'
        })
      } else {
        this.$router.push({
          path: '/index',
          query: {
            dir: this.dir
          }
        })
      }
    },
    // 列表播放模式选择
    onPlayMode(mode) {
      if (this.playMode === mode) mode = '0'
      this.playMode = mode
      localStorage.setItem('playMode', mode)
    },
    // 视频收藏
    onAvCollect() {
      avCollect({ aid: this.videoId }).then(res => {
        this.isAvCollect = !this.isAvCollect
      })
    },
    // 情景视频播放
    onScenarioVideo(isplay = false) {
      var that = this
      this.isScenarioVideo = true
      this.isFindIframe = false
      this.isSentence = false
      getSubtitle({ md5: this.sceneVideoMd5 }).then(res => {
        this.sceneVideoSubtitle = res.data
      })
      this.$nextTick(() => {
        // 播放事件
        this.$refs.sceneVideo.addEventListener('play', function() {
          that.$refs.sceneVideo.controls = true
          that.sceneVideoIsPlay = true
        })

        // 暂停事件
        this.$refs.sceneVideo.addEventListener('pause', function() {
          that.$refs.sceneVideo.controls = false
          that.sceneVideoIsPlay = false
        })
        if (isplay) {
          that.$refs.sceneVideo.play()
        }
      })
    },
    // 搜索情景视频
    onSceneVideo() {
      this.isModelSentence = 3
      getAvName({
        name: this.youdaoTitel.trim()
      }).then(res => {
        console.log(res)
        if (res.data?.exact) {
          this.sceneVideoUrl = res.data.exact.url
          this.scenarioVideoBut = true
          this.sceneVideoMd5 = res.data.exact.md5
          this.scenedim = res.data.dim
          this.onScenarioVideo(true)
        } else {
          this.scenarioVideoBut = false
          this.sceneVideoUrl = ''
          this.sceneVideoMd5 = ''
          this.scenedim = []
        }
      })
    },
    // Ai情景视频
    onAiSceneVideo() {
      this.isModelSentence = 4
      this.sceneVideoList = []
      this.sceneVideoIndex = -1
      this.isLogin = true
      wordPastFuture({
        word: this.youdaoTitel.trim(),
        s1: this.s1,
        s2: this.s2
      }).then(res => {
        this.isLogin = false
        res.data.past.forEach(x => { x.type = -1 })
        res.data.future.forEach(x => { x.type = 1 })
        this.sceneVideoList = res.data.past
        if (this.sceneVideoList.length === 0) return
        this.sceneVideoList = this.sceneVideoList.concat(res.data.future)
        this.sceneVideoUrl = this.sceneVideoList[0].url
        this.sceneVideoIndex = 0
      })
    },
    onDim(item) {
      this.sceneVideoUrl = item.url
      this.scenarioVideoBut = true
      this.sceneVideoMd5 = item.md5
      this.sceneVideoSubtitle = []
      this.subtitle = {}
      this.onScenarioVideo(true)
    },
    // 情景视频左键点击
    onsSceneVideoClickLeft() {
      if (this.isModelSentence === 3) {
        if (!this.sceneVideoIsPlay) this.$refs.sceneVideo.play()
      }
      if (this.isModelSentence === 4) {
        if (!this.sceneVideoIsPlay) {
          this.$refs.sceneVideo.play()
          this.sceneVideoIsPlay = true
        } else {
          this.$refs.sceneVideo.pause()
          this.sceneVideoIsPlay = false
        }
      }
    },
    // 情景视频播放
    onSceneVideoPlay() {
      this.$refs.sceneVideo.currentTime = this.sceneVideoList[this.sceneVideoIndex].startMillisecond / 1000
    },
    // 情景视频播放进度
    onTimeupdate(e) {
      const currentMillisecondCeil = Math.ceil(this.$refs.sceneVideo.currentTime * 1000)
      if (this.isModelSentence === 3) {
        const currentSubtitle = this.sceneVideoSubtitle.find((x, index) => {
          if (x.startMillisecond <= currentMillisecondCeil) {
            return true
          }
          return false
        })
        this.subtitle = currentSubtitle
      }
      if (this.isModelSentence === 4) {
        var videoObj = this.sceneVideoList[this.sceneVideoIndex]
        if (currentMillisecondCeil >= videoObj.endMillisecond) {
          if (this.sceneVideoIndex < this.sceneVideoList.length - 1) {
            this.$refs.sceneVideo.pause()
            var lodItem = this.sceneVideoList[this.sceneVideoIndex]
            this.sceneVideoIndex += 1
            var newItem = this.sceneVideoList[this.sceneVideoIndex]
            if (lodItem.id === newItem.id) {
              this.$refs.sceneVideo.currentTime = this.sceneVideoList[this.sceneVideoIndex].startMillisecond / 1000
              this.$refs.sceneVideo.play()
            } else {
              this.sceneVideoUrl = this.sceneVideoList[this.sceneVideoIndex].url
            }
          } else {
            this.$refs.sceneVideo.pause()
            this.sceneVideoIndex = 0
            this.sceneVideoUrl = this.sceneVideoList[this.sceneVideoIndex].url
          }
        }
      }
    },
    // 设置有道翻译字体
    onYoudaoTextSize(e) {
      localStorage.setItem('youdaoTextSize', e)
    },
    // 情景视频播放按钮处理
    sceneBut(e) {
      document.getElementsByClassName('scene-paly').forEach(ele => {
        var scene = ele.getClientRects()
        for (let index = 0; index < scene.length; index++) {
          var s = scene[index]
          if ((e.x >= s.x && e.x <= s.x + s.width) && (e.y >= s.y && e.y <= s.y + s.height) && !this.isSelectedTake) {
            ele.getElementsByClassName('scenebut')[0].style.opacity = 1
            break
          } else {
            if (ele.getElementsByClassName('scenebut')[0].style.opacity === '1' || ele.getElementsByClassName('scenebut')[0].style.opacity === 1) {
              var but = ele.getElementsByClassName('scenebut1')[0].getClientRects()[0]
              if (!((e.x >= but.x && e.x <= but.x + but.width) && (e.y >= but.y && e.y <= but.y + but.height))) {
                ele.getElementsByClassName('scenebut')[0].style.opacity = 0
              }
            } else {
              ele.getElementsByClassName('scenebut')[0].style.opacity = 0
            }
          }
        }
      })
    },
    // 机译
    onTranslation(item) {
      fygTranslate({ word: item.englishText }).then(res => {
        item.tempHtml = item.tempHtml.replace('无中文字幕，可选择机译', res.data.transResult)
        item.tempHtml = item.tempHtml.replace('style="opacity: 0;"', 'style="opacity: 1;"')
      })
    },
    // 柯林斯英英词典
    onKls() {
      this.klsLoading = true
      this.getHtml(`https://www.collinsdictionary.com/zh/dictionary/english/${this.youdaoTitel}`).then((htmlText) => {
        if (htmlText !== null) {
          kls({ html: htmlText, htmlType: 'KeLinShi' }).then(res => {
            this.klsHtml = res.data
            this.klsLoading = false
          })
        } else {
          console.log('无法获取HTML内容')
        }
      })
    },
    // 获取 url-html内容
    async  getHtml(url) {
      try {
        const response = await fetch(url)

        if (!response.ok) {
          throw new Error('网络错误')
        }

        return await response.text()
      } catch (error) {
        console.log(`获取HTML失败：${error}`)
        return null
      }
    },
    // 柯林斯发音
    onKeLinShiAudio(url) {
      this.audio.src = url
      this.audio.play()
    },
    // 剑桥中英词典
    onJq() {
      this.jqLoading = true
      kls({ html: `https://dictionary.cambridge.org/zhs/%E8%AF%8D%E5%85%B8/%E8%8B%B1%E8%AF%AD-%E6%B1%89%E8%AF%AD-%E7%AE%80%E4%BD%93/${this.youdaoTitel}`, htmlType: 'JianQiao' }).then(res => {
        this.jqHtml = res.data
        this.jqLoading = false
      })
      // this.getHtml(`https://dictionary.cambridge.org/zhs/%E8%AF%8D%E5%85%B8/%E8%8B%B1%E8%AF%AD-%E6%B1%89%E8%AF%AD-%E7%AE%80%E4%BD%93/${this.youdaoTitel}`).then((htmlText) => {
      //   if (htmlText !== null) {
      //     kls({ html: htmlText, htmlType: 'JianQiao' }).then(res => {
      //       this.jqHtml = res.data
      //       this.jqLoading = false
      //     })
      //   } else {
      //     console.log('无法获取HTML内容')
      //   }
      // })
    },
    // 记录默认翻译顺序
    onHtmlType(e) {
      localStorage.setItem('HtmlType', e)
    },
    // Ai释义发音
    onPayAi(index) {
      speechSynthesisToken().then(res => {
        var url = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=lxOnXI4KNOvwNSI1&token=${res.data}&text=${this.aiExplainTexts[ index ]}&format=mp3&voice=cindy&volume=100`
        this.audio.src = url
        this.audio.play()
      })
    },
    // 阿里单词发言
    aliPay(type) {
      speechSynthesisToken().then(res => {
        var url = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=lxOnXI4KNOvwNSI1&token=${res.data}&text=${this.youdaoTitel}&format=mp3&voice=${type}&volume=100`
        this.audio.src = url
        this.audio.play()
      })
    },
    // 单句播放暂停
    onSimplePause() {
      this.simplePause = !this.simplePause
      localStorage.setItem('simplePause', this.simplePause)
      this.simplePauseFill.fill = !this.simplePause
        ? this.isScreen
          ? 'white'
          : 'white'
        : '#C61200'
      if (!this.isPlay) {
        this.player.play()
        this.dialogAssociationVisible = false
        this.onMouseleaveSubtitle()
      }
    },
    // 阿里单词发言
    aliPayText(text) {
      speechSynthesisToken().then(res => {
        var url = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=lxOnXI4KNOvwNSI1&token=${res.data}&text=${text}&format=mp3&voice=cindy&volume=100`
        this.audio.src = url
        this.audio.play()
      })
    }
  }
}
</script>
<style lang="less" scoped>
//变量定义
@primary-clor: #c61200;
@padding-horizontal: 20px;
@padding-vertical: 10px;
@list-operation-height: 50px;
@tabs-top-height: 40px;
//左侧菜单宽度
@aside-width: 300px;

/*垂直居中*/
.vertical-center {
  display: flex;
  align-items: center;
}
// 隐藏全屏按钮
video::-webkit-media-controls-fullscreen-button {
  display: none;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

//图片占位和加载失败的样式
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}

//布局开始
.layout {
  margin: 0px;
  min-height: 0;
  background: #f1f1f1;
  // border-radius: 10px;
  //左侧导航
  .aside {
    //tabs 容器
    .tabs {
      height: calc(100% - 20px);
      position: relative;
      // tabs 顶部
      &-top {
        height: @tabs-top-height;
        display: flex;
        align-items: center;
        text-align: center;
        //tabs顶部项
        .item {
          width: 200px;
          height: @tabs-top-height;
          cursor: pointer;
          font-size: 14px;
          color: rgb(134, 134, 134);
          line-height: @tabs-top-height;
          //激活状态的样式
          &.is-active {
            color: @primary-clor;
            position: relative;
            &:after {
              content: '';
              width: 10px;
              height: 5px;
              border-radius: 5px;
              background: @primary-clor;
              position: absolute;
              bottom: -2px;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      //tabs的内容
      &-content {
        height: calc(100% - @tabs-top-height);
        //视频列表
        .list {
          box-sizing: border-box;
          padding: 10px 0px;
          // padding: @padding-vertical @padding-horizontal;
          //计算高度 =内容高度 - operation元素的高度
          height: calc(100% - @list-operation-height);
          //播放列表卡片
          .card {
            cursor: pointer;
            position: relative;
            box-sizing: border-box;
            padding: @padding-vertical @padding-horizontal;
            //激活状态处理
            &.is-active {
              .title {
                color: #b62b1a !important;
                font-weight: 700;
              }
              .frame{
                border: 2px solid #c61200 !important;
              }
              .paly{
                fill:#c61200 !important;
              }
            }
            //卡片头部
            &-header {
              display: flex;
              //卡片图片
              .thumb {
                width: 120px;
                height: 90px;
                margin-right: 8px;
                ::v-deep .el-image {
                  width: 120px;
                  height: 90px;
                  border-radius: 4px 0px 0px 4px;
                }
              }
              //卡片内容
              .content {
                flex: 1;
                .title {
                  height: 25px;
                  line-height: 25px;
                  color: #333333;
                  font-size: 12px;
                }
                .time {
                  height: 25px;
                  line-height: 25px;
                  color: rgb(136, 134, 134);
                  font-size: 12px;
                  position: absolute;
                  bottom: 10px;
                }
              }
            }
          }
        }
        //操作
        .operation {
          height: 40px !important;
          background: white;
          // height: @list-operation-height;
          width: calc(100% - 20px);
          border-radius: 5px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          // div {
          //   padding: 0 30px;
          // }
          div > svg {
            width: 20px;
            height: 20px;
          }
        }

        //笔记
        .note {
          height: calc(100%);
          width: @aside-width;
          word-wrap: break-word;
          box-sizing: border-box;
          padding: @padding-vertical @padding-horizontal;
          .row {
            width: 100%;
            margin-top: 10px;
            margin-bottom: 15px;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: rgb(236, 236, 236);
            //图片
            .img {
              float: left;
              margin-right: 10px;
            }
            ::v-deep .el-image {
              // width: 50px;
              // height: 50px;
            }
            //英文笔记
            .en {
              color: @primary-clor;
              letter-spacing: 1px;
              width: 100%;
              word-wrap: break-word;
              font-size: 12px;
            }
            //中文
            .zh {
              margin-top: 4px;
              font-size: 12px;
              color: rgb(90, 90, 90);
              margin-bottom: 5px;
              white-space: pre-line;
            }
          }
        }
      }
    }
  }
  //主体
  .main {
    overflow-y: auto;
    .body {
      padding: 10px;
      position: relative;
      // padding: 0 20px;
      width: 100%;
      &-container {
        width: 100%;
        height: 100%;
        //
        .index {
          position: relative;
          // background: #000;
          .modal-wrapper {
            position: absolute;
            z-index: 2007;
            background-color: rgba(46, 45, 45, 0.8);
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            margin: 0px;
            transition: opacity 0.3s ease 0s;
          }
          .modal {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 2008;
            width: 100%;
            text-align: center;
            vertical-align: middle;
            transform: translate(-50%, -50%);
            ::v-deep .el-result__title p {
              color: #dcdfe6;
            }
            ::v-deep .el-result__subtitle p {
              color: #dcdfe6;
            }
          }
          /* 毛玻璃效果 */
          .blur {
            -webkit-filter: blur(50px);
            -moz-filter: blur(50px);
            -ms-filter: blur(50px);
            filter: blur(10px) brightness(0.4);
            background-size: 150% 150%;
            // -webkit-filter: brightness(0.30);
            // filter: brightness(0.30);
          }
        }
        .empty {
          width: 100%;
          height: 100%;
        }
        .index {
          width: 100%;
          height: 100%;
          // padding: 10px;
          // position: relative;
          .video-js {
            width: 100%;
            height: 100%;
          }
          .video-radius {
            border-radius: 10px;
          }
          .video-radius-angle {
            border-radius: 10px 0px 0px 10px;
          }
        }
      }
      /*字幕部分 */
      &-subtitle {
        // position: absolute;
        z-index: 22;
        text-align: center;
        // bottom: 10px;
        max-width: 80%;
        // left: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        // transform: translate(-50%, -50%);
        .zh {
          order: 2;
          // -webkit-text-stroke: 0.6px white;
          // font-weight: bold;
          font-size: 18px;
          color: white;
          margin-top: 5px;
          background: rgba(36, 36, 36, 0.75);
          border-radius: 5px;
          padding: 5px 0px;
          span {
            padding: 20px;
          }
          &.hide {
            opacity: 0;
          }
          &.show {
            opacity: 1;
          }
        }
        .zh:hover {
          opacity: 1;
        }
        .en {
          order: 1;
          opacity: 1;
        }
        //视频模糊情况下字幕的情况
        &.blur {
          //普通
          .en,
          .zh {
            opacity: 0;
          }
          .zh {
            color: white;
          }
          //鼠标移入效果
          .en:hover {
            opacity: 1;
          }
          .zh:hover {
            opacity: 1;
          }
          .zh:hover + .en {
            opacity: 1;
          }
        }
        //隐藏字幕的情况下
        &.hide {
          //普通
          .en,
          .zh {
            opacity: 0;
          }
          .zh {
            color: white;
          }
          //鼠标移入效果
          .en:hover {
            opacity: 1;
          }
          .zh:hover {
            opacity: 0.4;
          }
          .zh:hover + .en {
            opacity: 1;
          }
        }
        .en {
          padding: 5px 20px;
          position: relative;
          border-radius: 5px;
          background: #5961cdd0;
          font-weight: bold;
          font-size: 20px;
          // max-width: 80%;
          color: white;
          //动画定义
          @keyframes warn {
            0% {
              transform: scale(0.3);
              -webkit-transform: scale(0.3);
              opacity: 0;
            }
            25% {
              transform: scale(0.3);
              -webkit-transform: scale(0.3);
              opacity: 0.1;
            }
            50% {
              transform: scale(0.5);
              -webkit-transform: scale(0.5);
              opacity: 0.3;
            }
            75% {
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              opacity: 0.5;
            }
            100% {
              transform: scale(1);
              -webkit-transform: scale(1);
              opacity: 0;
            }
          }
          @keyframes warn1 {
            0% {
              transform: scale(0.3);
              -webkit-transform: scale(0.3);
              opacity: 0;
            }
            25% {
              transform: scale(0.3);
              -webkit-transform: scale(0.3);
              opacity: 0.1;
            }
            50% {
              transform: scale(0.3);
              -webkit-transform: scale(0.3);
              opacity: 0.3;
            }
            75% {
              transform: scale(0.5);
              -webkit-transform: scale(0.5);
              opacity: 0.5;
            }
            100% {
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              opacity: 0;
            }
          }
          //字幕联想
          .association {
            cursor: pointer;
            transform: translate(-50%, -50%);
            position: absolute;
            right: -80px;
            top: 50%;
            .contanier {
              position: relative;
              width: 50px;
              height: 50px;
              /* 保持大小不变的小圆点 */
              .dot {
                position: absolute;
                width: 10px;
                height: 10px;
                left: 15px;
                top: 15px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border: 5px solid @primary-clor;
                border-radius: 50%;
                background-color: #ffff;
                z-index: 2;
              }
              /* 产生动画（向外扩散变大）的圆圈 第一个圆 */
              .pulse {
                position: absolute;
                width: 45px;
                height: 45px;
                left: 0;
                top: 0;
                border: 3px solid @primary-clor;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                z-index: 1;
                opacity: 0;
                -webkit-animation: warn 2s ease-out;
                -moz-animation: warn 2s ease-out;
                animation: warn 2s ease-out;
                -webkit-animation-iteration-count: infinite;
                -moz-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
                box-shadow: 1px 1px 30px @primary-clor; /* 阴影效果 */
              }
              /* 产生动画（向外扩散变大）的圆圈 第二个圆 */
              .pulse1 {
                position: absolute;
                width: 45px;
                height: 45px;
                left: 0;
                top: 0;
                border: 3px solid @primary-clor;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                z-index: 1;
                opacity: 0;
                -webkit-animation: warn1 2s ease-out;
                -moz-animation: warn1 2s ease-out;
                animation: warn1 2s ease-out;
                -webkit-animation-iteration-count: infinite;
                -moz-animation-iteration-count: infinite;
                animation-iteration-count: infinite;
                box-shadow: 1px 1px 30px @primary-clor; /* 阴影效果 */
              }
            }
          }
        }
      }
      // 收缩栏
      .cont {
        position: absolute;
        top: 0px;
        right: 0px;
        height: 100%;
        // 左右上下居中
        display: flex;
        justify-content: center;
        align-items: center;
        // background: rgb(44, 44, 44);
        .cont-but {
          background: #5961cd;
          border-radius: 5px 0px 0px 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
        }
        i {
          right: 0px;
          color: white;
        }
      }
      // 右侧菜单
      .right-menu {
        // 左右上下居中
        display: flex;
        justify-content: center;
        align-items: center;
        .menu-hollow {
          overflow: hidden;
          border-radius: 6px;
          width: 40px;
          background: #060606d1;
          .menu-hollow-but {
            font-size: 12px;
            color: #ffffff;
            // 左右上下居中
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin-top: 8px;
              width: 16px;
              height: 18px;
            }
            label {
              margin-top: 4px;
              margin-bottom: 4px;
            }
            .text-not-select {
              color: #bbbbbb;
            }
          }
          .menu-hollow-but-select {
            background: #b62b1a !important;
          }
        }
        .feedback-but {
          margin-top: 10px;
          border-radius: 6px;
          width: 30px;
          height: 30px;
          background: #060606d1;
          // // 左右上下居中
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin: 10px;
          }
        }
      }
    }
    .body-screen {
      padding: 0px !important;
    }
  }

  .layout-contoller {
    padding: 0px 0px 0px 0px;
    width: calc(100% - 0px);
    ::v-deep .el-slider__button {
      width: 4px;
      height: 4px;
    }
  }

  //控制面板
  &-contoller {
    height: auto !important;
    //播放进度条
    .progress {
      display: flex;
      align-items: center;
      // padding: 5px 0;
      .progress-bar {
        flex: 1;
        margin: 0 5px;
      }
      .start-time {
        width: 50px;
        font-size: 12px;
        color: white;
        text-align: left;
        margin-left: 10px;
      }
      .end-time {
        width: 50px;
        font-size: 12px;
        color: white;
        text-align: right;
        margin-right: 10px;
      }
      .feedback {
        width: 20px;
        height: 20px;
        background: #ffe100;
        // 左右上下居中
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    //控制部分
    .control {
      // margin: 10px 0;
      display: flex;
      justify-content: space-between;
      //播放
      .paly {
        margin-left: 10px;
        width: 300px;
        display: flex;
        cursor: pointer;
        align-items: center;
        .play-pause {
          width: 36px;
          height: 36px;
          margin-right: 20px;
          border-radius: 10px;
          text-align: center;
          vertical-align: middle;
          margin-bottom: 5px;
          background: #5961cd;
          .play-icon {
            width: 28px;
            height: 28px;
            margin-left: 4px;
            margin-top: 4px;
          }
          .pause-icon {
            width: 22px;
            height: 22px;
            margin-top: 8px;
          }
        }
        .voice {
          flex: 1;
          display: flex;
          align-items: center;
          &__svg {
            width: 40px;
            padding-top: 4px;
            svg {
              fill: @primary-clor;
              width: 20px;
              height: 20px;
            }
          }
          &__slider {
            flex: 1;
          }
          .addnote {
            margin-left: 20px;
            width: 90px;
          }
        }
      }
      //功能
      .function {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
          padding: 0 10px;
          cursor: pointer;
        }
        svg {
          width: 14px;
          height: 14px;
          padding: 0px 10px;
        }
        .speed-rate {
          font-size: 16px;
        }
        .fullscreen {
          width: 20px;
          height: 20px;
          padding: 0px 0px 0px 20px;
        }
        .el-dropdown {
          width: 20px;
        }
      }
    }
  }

  //有道词典弹框
  .dialogDictionary {
    ::v-deep .el-dialog__body {
      height: 400px;
      overflow: hidden;
    }
    .dialog-footer {
      text-align: right;
    }
    .iframe {
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
      .hiddenScrollX {
        position: absolute;
        bottom: 0;
        right: -20px;
        width: 105%;
        height: 20px;
        background: #ffff;
      }
      iframe {
        margin-top: -260px;
        margin-left: 20px;
        width: 790px;
        height: 850px;
      }
    }
  }

  //联想视频弹框
  .dialogAssociation {
    ::v-deep .el-dialog__body {
      height: 350px;
    }
    .note {
      border: 2px solid #eee;
      border-radius: 10px;
      margin-right: 10px;
      overflow: hidden;
      .list {
        list-style-type: demical !important;
      }
    }
    .video {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 0 !important;
      .video-js {
        width: 100%;
        height: 350px;
      }
    }
  }

  //添加笔记
  .dialogAddNote {
    //屏幕
    .screen {
      //图片
      ::v-deep .el-image {
        width: 100%;
        height: 400px;
        .image-slot {
          font-size: 40px;
        }
      }
      margin-bottom: 5px;
      position: relative;
      //字幕
      .subtitle {
        position: absolute;
        bottom: 25px;
        text-align: center;
        z-index: 100;
        left: 50%;
        max-width: 80%;
        transform: translate(-50%);
        .en {
          background: #000;
          border-radius: 10px;
          font-size: 17px;
          padding: 10px 20px;
          word-wrap: break-word;
          color: #ffff;
        }
        .zh {
          // -webkit-text-stroke: 0.6px white;
          font-weight: bold;
          font-size: 18px;
          color: #ffff;
          opacity: 0.4;
          margin-top: 5px;
        }
      }
    }
  }
}

.layout-screen {
  margin: 0px !important;
  border-radius: 0px;
}
.layout-contoller-Screen {
  // background: black;
  width: calc(100% - 0px) !important;
  bottom: 0px !important;
  padding: 0px !important;
}

//所有的滚动条
.scrollbar {
  height: 100%;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.take-background {
  background: #f7dc00;
  color: #282828;
  // border-radius: 3px;
}
//禁止文本选择
* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.subtitle-div {
  display: flex;
  align-items: center;
  justify-content: center;
  // position: absolute;
  // bottom: 95px;
  width: 100%;
}
.hepl-tooltip {
  font-size: 14px;
  color: #c61200;
  font-weight: bold;
  margin-bottom: 4px;
}
.hepl-info {
  font-size: 12px;
  margin-bottom: 4px;
}
//新版笔记
.note-div {
  left: 0px;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0);
  z-index: 100;
  //视频
  .note-video {
    background: white;
    border-radius: 5px;
    width: 300px;
    margin-left: 10px;
    margin-top: 10px;
    // 左右上下居中
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
      height: 100%;
      border-radius: 5px 5px 5px 5px;
      // margin-bottom: 5px;
    }
    .play {
      position: absolute;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      text-align: center;
      vertical-align: middle;
      border: 1px solid @primary-clor;
      box-shadow: 0px 0px 5px @primary-clor;
      svg {
        margin-left: 8px;
        margin-top: 4px;
      }
    }
    .control {
      position: relative;
      height: 24px;
      .but {
        position: absolute;
        right: 10px;
      }
      svg {
        margin-left: 10px;
      }
    }
  }
  //笔记
  .note-row {
    background: white;
    border-radius: 5px;
    position: relative;
    width: 300px;
    margin-left: 10px;
    margin-top: 10px;
    .head {
      margin-top: 2px;
      margin-left: 2px;
    }
    .name {
      margin-left: 10px;
      font-size: 14px;
      margin-top: 10px;
      color: #4d4d4d;
    }
    .time {
      font-size: 12px;
      position: absolute;
      right: 10px;
      top: 10px;
      color: #8c8c8c;
    }
    .content {
      font-size: 12px;
      max-width: 300px;
      padding: 5px;
      color: #515151;
      white-space: pre-line;
    }
    .control {
      position: relative;
      height: 24px;
      .but {
        position: absolute;
        right: 10px;
        span {
          font-size: 11px;
          color: rgb(151, 151, 151);
        }
      }
      svg {
        margin-left: 10px;
      }
    }
  }
}
.word {
  position: absolute;
  bottom: -1px;
  left: 20px;
  z-index: -1;
  span {
    // margin-right: 5px;
    color: rgba(0, 0, 0, 0);
    border-width: 0px 0px 2px 0px;
    // height: 2px;
    border-style: solid;
  }
}
//情景视频
.scene-video {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: red;
  height: 80px;
}
//情景视频列表
.sceneVideoList {
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-height: auto;
  z-index: 100;
  background: rgb(36, 36, 36);
  // word-break: break-all;
  .sceneVideoListScrollbar {
    width: 100%;
  }
  .sceneVideoItem {
    position: relative;
    display: inline-block;
    padding: 10px;
    img {
      width: 260px;
      height: 140px;
    }
    .name {
      position: absolute;
      bottom: 0px;
      width: 100%;
      background: rgba(31, 31, 31, 0.808);
      overflow: hidden;
      span {
        white-space: nowrap;
        text-overflow: ellipsis;
        color: white;
        overflow: hidden;
        max-width: 260px;
      }
      .title {
        font-size: 12px;
        padding: 2px 5px 2px 5px;
      }
      .wordKey {
        font-size: 12px;
        padding: 5px 5px 2px 5px;
        color: #b3b2b2;
      }
      .subtitle {
        font-size: 12px;
        padding: 0px 30px 2px 5px;
        color: #b3b2b2;
      }
    }
  }
}
//联想视频视频播放框
.scene-video-popup {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(17, 17, 17, 0.7);
  top: 0px;
  left: 0px;
  z-index: 10000;
  // 左右上下居中
  display: flex;
  justify-content: center;
  align-items: center;
  .video {
    width: 80%;
    height: 80%;
    background: rgb(0, 0, 0);
    border-style: solid;
    border-width: 4px;
    border-color: black;
    position: relative;
    border-radius: 5px;
    video {
      width: 100%;
      height: 100%;
    }
    .control {
      position: absolute;
      bottom: 10px;
      width: 100%;
      // 左右上下居中
      display: flex;
      justify-content: center;
      align-items: center;
      .control-but {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px 23px;
        background: #0d0d0dcb;
        border-radius: 5px;
      }
      //播放按钮
      .play {
        width: 40px;
        height: 40px;
        margin-left: 20px;
        margin-right: 20px;
        border-radius: 50%;
        text-align: center;
        vertical-align: middle;
        border: 1px solid #eee;
        box-shadow: 0px 0px 5px white;
        .play-icon {
          width: 30px;
          height: 30px;
          margin-left: 4px;
          margin-top: 4px;
        }
        .pause-icon {
          width: 22px;
          height: 22px;
          margin-top: 8px;
        }
      }
      span {
        padding: 0px 10px;
      }
    }
  }
  .close {
    position: absolute;
    top: 10px;
    width: 30px;
    height: 30px;
    right: 10px;
    background: #0d0d0dcb;
    color: white;
    border-radius: 30px;
    font-size: 14px;
    // padding: 5px;
    // 左右上下居中
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
// 收缩栏
.contraction {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  // 左右上下居中
  display: flex;
  justify-content: center;
  align-items: center;
  // background: rgb(44, 44, 44);
  i {
    right: 0px;
  }
}
.hollow {
  position: absolute;
  right: 20px;
  top: 20px;
}
// 挖空
.hollow-div {
  position: absolute;
  top: 0px;
  right: 0px;
  height: calc(100% - 67px);
  width: 70%;
 // background: black;
  z-index: 100;
  display: inline;
  word-wrap: break-word;
  border-radius: 0px 10px 0px 0px;
  overflow: hidden; //溢出问题处理
  //  border-style: solid;
  //  border-width: 1px;
  //  border-color: #515151;
  .hollow-title {
    background: black;
    width: 100%;
    position: relative;
    z-index: 1;
    // height: 30px;
    .but {
      width: 60px;
      height: 100%;
      color: white;
      // font-size: 12px;
      // 左右上下居中
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .line {
      border-width: 0px 0px 2px 0px;
      border-color: white;
      border-style: solid;
    }
  }
  .hollow-subtit {
    background: #333333;
    font-size: 13px;
    white-space: normal;
    padding: 10px 8px;
    margin-top: 15px;
    color: white;
    display: flex;
    align-items: center;
    flex-flow: wrap;
    .hollow-word {
      cursor: pointer;
      border-width: 2px 0px 2px 0px;
      border-style: solid;
      border-color: transparent;
    }
    .hollow-blank {
      cursor: pointer;
      border-width: 2px 0px 2px 0px;
      border-style: solid;
      border-color: transparent;
    }
    .hollow-hide {
      color: transparent;
      border-bottom-color: #c71100 !important;
    }
    .hollow-hide-prominent {
      color: white !important;
    }
    .hollow-hide-division {
      color: transparent;
      border-bottom-color: #dbff00 !important;
    }
  }
  .hollow-subtit-play {
    background: #5961cdd0 !important;
  }
}
.hollow-div-screen {
  border-radius: 0px !important;
}
// 例句
.ms-row {
  margin: 10px 0px;
  padding: 5px;
  border-width: 0 0 1px 0;
  border-color: #ffffff62;
  border-style: solid;
  .ms-english {
    font-weight: bold;
    display: flex;
    align-items: center;
    // justify-content: center;
    // color: #ffffff;
    font-size: 14px;
    margin-bottom: 5px;
    .frequency {
      padding: 0px 8px;
      color: white;
      border-radius: 2px;
      font-size: 12px;
      font-weight: normal;
      margin-left: 4px;
    }
    .play {
      width: 28px;
      height: 28px;
      border-radius: 5px;
      // 左右上下居中
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 12px;
        height: 12px;
      }
    }
  }

  .ms-chinese {
    color: #646363;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .ms-provenance {
    color: #8b8b8b;
    font-size: 12px;
  }
}
//笔记按钮
.notes-news {
  background: #5961cd;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  // 左右上下居中
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
  }
}
</style>
<style>
/* .el-popper[x-placement^='top'] {
  background: #090909ed;
} */
.el-tooltip__popper {
  padding: 6px !important;
}
.el-slider__button {
  width: 0px !important;
  height: 0px !important;
}
.el-slider__runway {
  height: 2px;
  background-color: #d0d0d032 !important;
}
.el-slider__bar {
  height: 2px;
  background-color: #c61200 !important;
}
.el-slider__button {
  border: solid 4px #c61200 !important;
  margin-top: -4px !important;
}
.el-tooltip__popper {
  padding: 6px !important;
}
.el-dialog__body{
  padding: 10px 20px;
}
</style>
